<template lang="html">
  <div>
    <v-app-bar app flat color="white" height="72">
      <v-container class="px-0">
        <v-row>
          <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
            <div class="d-flex align-center">
              <v-btn icon width="40" height="40" class="mr-2" @click="goBack()">
                <v-icon>
                  mdi-arrow-left
                </v-icon>
              </v-btn>
              <div class="title-page-text">
                {{ $t('v2.order_detail') }}
              </div>
              <v-spacer />
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>
    <v-container class="pt-0">
      <v-row>
        <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pt-0">
          <div v-if="order.status_inquiry === 5" :class="['banner-resorder text-center', { 'order-success': order.status_inquiry === 5 }]">
            <div class="mb-4">
              <img src="@/assets/images/v2/img/icon_check.png" alt="" class="image-144 ma-auto">
            </div>
            <div class="font-16 font-weight-600">
              {{ $t('v2.order_completed') }}
            </div>
          </div>
          <div v-if="order.is_paid && (order.status_inquiry === 1 || order.status_inquiry === 2 || (order.status_inquiry === 3 && (!order.shipping_log.shipper || $isEmpty(order.shipping_log.shipper))) || (order.status_inquiry === 4 && (!order.shipping_log.shipper || $isEmpty(order.shipping_log.shipper))))" class="ol-elevation-2 mb-4 br-8 pa-4">
            <div class="flex-image">
              <div class="flex-image-avatar mr-4">
                <img src="@/assets/images/v2/img/icon_check.png" alt="" class="image-40">
              </div>
              <div class="flex-image-content">
                <div class="flex-image-content-text font-18 font-weight-700 mb-1">
                  {{ $t('v2.your_payment_was_successful') }}
                </div>
                <div class="flex-image-content-text font-14 font-weight-400">
                  <span v-mask-money="order.total_amount" />
                </div>
              </div>
            </div>
          </div>
          <div v-if="order.status_inquiry === 1 || order.status_inquiry === 2 || order.status_inquiry === 3 || order.status_inquiry === 4" :class="['banner-resorder', { 'order-ready-to-pickup': order.status === 'S' }]">
            <div class="container-lottie">
              <div v-if="order.status === 'S'" class="image-lottie">
                <svg width="64" height="76" viewBox="0 0 64 76" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.9995 0.611694H50.0003C51.035 0.611694 52.0273 1.02273 52.759 1.75439C53.4906 2.48604 53.9016 3.47837 53.9016 4.51308V16.8675H10.0981V4.51308C10.0981 3.47837 10.5092 2.48604 11.2408 1.75439C11.9725 1.02273 12.9648 0.611694 13.9995 0.611694Z" fill="#F2A66C" />
                  <path d="M41.7535 12.1156H22.2466V8.21418C22.2466 7.69683 22.4521 7.20066 22.8179 6.83483C23.1838 6.46901 23.6799 6.26349 24.1973 6.26349H39.8028C40.3202 6.26349 40.8164 6.46901 41.1822 6.83483C41.548 7.20066 41.7535 7.69683 41.7535 8.21418V12.1156Z" fill="#663325" />
                  <path d="M53.9032 12.1156H10.0971L0.36377 20.4594V71.487C0.36377 72.5217 0.774808 73.514 1.50646 74.2457C2.23811 74.9773 3.23045 75.3884 4.26516 75.3884H59.7351C60.7699 75.3884 61.7622 74.9773 62.4938 74.2457C63.2255 73.514 63.6365 72.5217 63.6365 71.487V20.4594L53.9032 12.1156Z" fill="#F2A66C" />
                  <path d="M63.6343 20.4567H0.366699L10.0942 12.1143H53.9068L63.6343 20.4567Z" fill="#D58559" />
                  <path d="M4.26535 55.1771C4.11589 55.1772 3.96788 55.1478 3.82979 55.0907C3.69169 55.0335 3.56622 54.9497 3.46054 54.844C3.35485 54.7384 3.27104 54.6129 3.21388 54.4748C3.15673 54.3367 3.12736 54.1887 3.12744 54.0392V50.0832C3.12744 49.7814 3.24733 49.492 3.46073 49.2786C3.67412 49.0652 3.96356 48.9453 4.26535 48.9453C4.56714 48.9453 4.85657 49.0652 5.06997 49.2786C5.28337 49.492 5.40325 49.7814 5.40325 50.0832V54.0392C5.40325 54.341 5.28337 54.6304 5.06997 54.8438C4.85657 55.0572 4.56714 55.1771 4.26535 55.1771Z" fill="#D58559" />
                  <path d="M22.2111 55.2598C22.0617 55.2599 21.9137 55.2305 21.7756 55.1734C21.6375 55.1162 21.512 55.0324 21.4063 54.9267C21.3007 54.8211 21.2168 54.6956 21.1597 54.5575C21.1025 54.4194 21.0732 54.2714 21.0732 54.1219V42.791C21.0732 42.4892 21.1931 42.1998 21.4065 41.9864C21.6199 41.773 21.9094 41.6531 22.2111 41.6531C22.5129 41.6531 22.8024 41.773 23.0158 41.9864C23.2292 42.1998 23.3491 42.4892 23.3491 42.791V54.1219C23.3491 54.2714 23.3198 54.4194 23.2626 54.5575C23.2055 54.6956 23.1216 54.8211 23.016 54.9267C22.9103 55.0324 22.7848 55.1162 22.6467 55.1734C22.5086 55.2305 22.3606 55.2599 22.2111 55.2598Z" fill="#DDDDE3" />
                  <path d="M19.444 64.6049L20.2549 49.6763H24.1673L24.9775 64.6049C24.998 64.981 24.9416 65.3572 24.8118 65.7107C24.6821 66.0642 24.4816 66.3875 24.2227 66.6609C23.9637 66.9343 23.6518 67.1521 23.3059 67.3009C22.9599 67.4497 22.5873 67.5265 22.2108 67.5264C21.8342 67.5264 21.4616 67.4496 21.1158 67.3007C20.7699 67.1519 20.458 66.9341 20.1991 66.6607C19.9402 66.3873 19.7397 66.064 19.6098 65.7106C19.48 65.3571 19.4236 64.9809 19.444 64.6049Z" fill="#EDEDF9" />
                  <path d="M28.3529 38.7042C28.3529 42.9444 25.603 45.7735 22.2114 45.7735C18.8198 45.7735 16.0693 42.9418 16.0693 38.7042C16.0693 34.4666 18.8192 30.4189 22.2114 30.4189C25.6037 30.4189 28.3529 34.4647 28.3529 38.7042Z" fill="#EDEDF9" />
                  <path d="M41.7893 55.2598C41.6398 55.2599 41.4918 55.2305 41.3537 55.1734C41.2156 55.1162 41.0901 55.0324 40.9845 54.9267C40.8788 54.8211 40.795 54.6956 40.7378 54.5575C40.6807 54.4194 40.6513 54.2714 40.6514 54.1219V42.791C40.6514 42.4892 40.7713 42.1998 40.9847 41.9864C41.1981 41.773 41.4875 41.6531 41.7893 41.6531C42.0911 41.6531 42.3805 41.773 42.5939 41.9864C42.8073 42.1998 42.9272 42.4892 42.9272 42.791V54.1219C42.9272 54.4237 42.8073 54.7131 42.5939 54.9265C42.3805 55.1399 42.0911 55.2598 41.7893 55.2598Z" fill="#DDDDE3" />
                  <path d="M39.0226 64.6049L39.8341 49.6763H43.7465L44.5574 64.6049C44.5778 64.981 44.5213 65.3572 44.3915 65.7107C44.2616 66.0642 44.0611 66.3876 43.8021 66.661C43.5431 66.9344 43.2311 67.1521 42.8852 67.3009C42.5392 67.4497 42.1666 67.5265 41.79 67.5264C41.4134 67.5264 41.0408 67.4496 40.6949 67.3007C40.349 67.1519 40.037 66.9341 39.7781 66.6608C39.5191 66.3874 39.3186 66.0641 39.1887 65.7106C39.0588 65.3572 39.0023 64.981 39.0226 64.6049Z" fill="#EDEDF9" />
                  <path d="M47.931 38.7041C47.931 42.6055 45.1812 45.7734 41.7889 45.7734C38.3966 45.7734 35.6475 42.6081 35.6475 38.7041H47.931Z" fill="#EDEDF9" />
                  <path d="M46.7927 39.8421C46.6432 39.8422 46.4952 39.8128 46.3571 39.7556C46.219 39.6985 46.0936 39.6147 45.9879 39.509C45.8822 39.4033 45.7984 39.2778 45.7412 39.1397C45.6841 39.0016 45.6547 38.8536 45.6548 38.7042V30.4189C45.6548 30.1171 45.7747 29.8277 45.9881 29.6143C46.2015 29.4009 46.4909 29.281 46.7927 29.281C47.0945 29.281 47.3839 29.4009 47.5973 29.6143C47.8107 29.8277 47.9306 30.1171 47.9306 30.4189V38.7042C47.9307 38.8536 47.9013 39.0016 47.8442 39.1397C47.787 39.2778 47.7032 39.4033 47.5975 39.509C47.4918 39.6147 47.3663 39.6985 47.2282 39.7556C47.0902 39.8128 46.9421 39.8422 46.7927 39.8421Z" fill="#EDEDF9" />
                  <path d="M43.4563 39.8421C43.1545 39.8421 42.865 39.7222 42.6516 39.5088C42.4382 39.2954 42.3184 39.006 42.3184 38.7042V30.4189C42.3184 30.1171 42.4382 29.8277 42.6516 29.6143C42.865 29.4009 43.1545 29.281 43.4563 29.281C43.7581 29.281 44.0475 29.4009 44.2609 29.6143C44.4743 29.8277 44.5942 30.1171 44.5942 30.4189V38.7042C44.5943 38.8536 44.5649 39.0016 44.5077 39.1397C44.4506 39.2778 44.3668 39.4033 44.2611 39.509C44.1554 39.6147 44.0299 39.6985 43.8918 39.7556C43.7537 39.8128 43.6057 39.8422 43.4563 39.8421Z" fill="#EDEDF9" />
                  <path d="M40.1208 39.8421C39.9714 39.8422 39.8234 39.8128 39.6853 39.7556C39.5472 39.6985 39.4217 39.6147 39.316 39.509C39.2103 39.4033 39.1265 39.2778 39.0694 39.1397C39.0122 39.0016 38.9828 38.8536 38.9829 38.7042V30.4189C38.9829 30.1171 39.1028 29.8277 39.3162 29.6143C39.5296 29.4009 39.819 29.281 40.1208 29.281C40.4226 29.281 40.712 29.4009 40.9254 29.6143C41.1388 29.8277 41.2587 30.1171 41.2587 30.4189V38.7042C41.2588 38.8536 41.2294 39.0016 41.1723 39.1397C41.1151 39.2778 41.0313 39.4033 40.9256 39.509C40.8199 39.6147 40.6945 39.6985 40.5564 39.7556C40.4183 39.8128 40.2703 39.8422 40.1208 39.8421Z" fill="#EDEDF9" />
                  <path d="M36.7844 39.8421C36.4826 39.8421 36.1932 39.7222 35.9798 39.5088C35.7664 39.2954 35.6465 39.006 35.6465 38.7042V30.4189C35.6465 30.1171 35.7664 29.8277 35.9798 29.6143C36.1932 29.4009 36.4826 29.281 36.7844 29.281C37.0862 29.281 37.3756 29.4009 37.589 29.6143C37.8024 29.8277 37.9223 30.1171 37.9223 30.4189V38.7042C37.9224 38.8536 37.893 39.0016 37.8359 39.1397C37.7787 39.2778 37.6949 39.4033 37.5892 39.509C37.4835 39.6147 37.358 39.6985 37.2199 39.7556C37.0819 39.8128 36.9338 39.8422 36.7844 39.8421Z" fill="#EDEDF9" />
                </svg>
              </div>
              <lottie v-else-if="order.status_inquiry === 1 || order.status_inquiry === 2" :options="pendingOption" />
              <lottie v-else-if="shipperDelivery" :options="shippingOption" />
              <lottie v-else-if="shipperSearch" :options="searchOption" />
              <lottie v-else-if="order.status_inquiry === 3 || order.status_inquiry === 4" :options="confirmOption" />
              <!-- shippingOption -->
            </div>
            <div v-if="order.status === 'S'" class="mt-4 text-center">
              <div class="font-16 font-weight-600 ol-black">
                {{ $t('v2.order_is_ready_for_pickup') }}
              </div>
            </div>
            <div v-else-if="order.status_inquiry === 1 || order.status_inquiry === 2" class="mt-4 text-center">
              <div class="font-14 ol-black mb-1 line-height-normal">
                {{ $t('v2.your_order_number') }}
              </div>
              <div class="font-24 font-weight-700 line-height-normal">
                {{ order.order_no }}
              </div>
            </div>
            <div v-else-if="shipperDelivery" class="mt-4 text-center">
              <div class="font-16 font-weight-600 ol-black">
                {{ $t('v2.order_is_on_delivery') }}
              </div>
            </div>
            <div v-else-if="shipperSearch" class="mt-4 text-center">
              <div class="font-16 font-weight-600 ol-black">
                {{ $t('v2.finding_driver') }}..
              </div>
            </div>
            <div v-else-if="order.status_inquiry === 3 || order.status_inquiry === 4 || (order.status_inquiry === 5 && order.status === 'T')" class="mt-4 text-center">
              <div class="font-16 font-weight-600 ol-black">
                {{ $t('v2.preparing_an_order') }}
              </div>
            </div>
          </div>
          <!-- {{ order.payment_log }} -->
          <div v-if="(order.status === 'A' || order.status === 'S' || order.status === 'T') && order.remark === 'DELIVERY'" class="status-order-stepper mb-4">
            <div class="status-order-stepper-item">
              <div class="status-order-stepper-icon">
                <svg v-if="shipperSearch" width="15" height="11" viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.16631 8.28722L2.14773 5.26864L0.851562 6.5648L5.16631 10.8796L14.0644 1.98147L12.7682 0.685303L5.16631 8.28722Z" fill="#0078CE" />
                </svg>
                <svg v-else width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18.8968 3.85012L16.1478 1.10196C15.9763 0.929624 15.7435 0.833374 15.4997 0.833374H4.49967C4.25584 0.833374 4.02301 0.929624 3.85159 1.10196L1.10251 3.85012C0.935674 4.01604 0.833008 4.24521 0.833008 4.49912V16.4167C0.833008 17.4278 1.65526 18.25 2.66634 18.25H17.333C18.3441 18.25 19.1663 17.4278 19.1663 16.4167V4.49912C19.1663 4.24521 19.0637 4.01604 18.8968 3.85012ZM4.87917 2.66671H15.1202L16.0359 3.58246H3.96342L4.87917 2.66671ZM2.66634 16.4167V5.41579H17.333L17.3348 16.4167H2.66634Z" fill="#0078CE" />
                  <path d="M12.7497 10H7.24967V8.16671H5.41634V11.8334H14.583V8.16671H12.7497V10Z" fill="#0078CE" />
                </svg>
              </div>
              <div class="status-order-stepper-text ol-brand">
                {{ $t('v2.prepared') }}
              </div>
            </div>
            <hr :class="['line-order-stepper', { 'olbrand': shipperSearch }]">
            <div class="status-order-stepper-item">
              <div class="status-order-stepper-icon">
                <svg v-if="shipperDelivery" width="15" height="11" viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.16631 8.28722L2.14773 5.26864L0.851562 6.5648L5.16631 10.8796L14.0644 1.98147L12.7682 0.685303L5.16631 8.28722Z" fill="#0078CE" />
                </svg>
                <svg v-else width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M0.833008 10C0.833008 5.03079 5.03042 0.833374 9.99967 0.833374C14.9689 0.833374 19.1663 5.03079 19.1663 10C19.1663 12.9242 17.707 15.5715 15.4997 17.2637V17.3334H15.4062C13.8772 18.4746 12.0044 19.1667 9.99967 19.1667C7.99492 19.1667 6.12217 18.4746 4.59317 17.3334H4.49967V17.2637C2.29234 15.5715 0.833008 12.9233 0.833008 10ZM9.08301 14.192C7.77034 14.192 6.67309 15.1169 6.40084 16.3498C7.47151 16.9704 8.70167 17.3334 9.99967 17.3334C11.2977 17.3334 12.5278 16.9704 13.5985 16.3498C13.3263 15.1178 12.229 14.192 10.9163 14.192H9.08301ZM10.9163 12.3586C12.8157 12.3586 14.4483 13.521 15.1422 15.171C16.4869 13.8335 17.333 11.9947 17.333 10C17.333 6.02446 13.9753 2.66671 9.99967 2.66671C6.02409 2.66671 2.66634 6.02446 2.66634 10C2.66634 11.9947 3.51242 13.8335 4.85717 15.171C5.55017 13.5219 7.18367 12.3586 9.08301 12.3586H10.9163ZM6.33301 8.16671C6.33301 6.07671 7.90967 4.50004 9.99967 4.50004C12.0897 4.50004 13.6663 6.07671 13.6663 8.16671C13.6663 10.2567 12.0897 11.8334 9.99967 11.8334C7.90967 11.8334 6.33301 10.2567 6.33301 8.16671ZM8.16634 8.16671C8.16634 9.24654 8.91984 10 9.99967 10C11.0795 10 11.833 9.24654 11.833 8.16671C11.833 7.08687 11.0795 6.33337 9.99967 6.33337C8.91984 6.33337 8.16634 7.08687 8.16634 8.16671Z" :fill="shipperSearch ? '#0078CE' : '#767676'" />
                </svg>
              </div>
              <div :class="['status-order-stepper-text', { 'ol-brand': shipperSearch }]">
                {{ $t('v2.finding_driver') }}
              </div>
            </div>
            <hr :class="['line-order-stepper', { 'olbrand': shipperDelivery }]">
            <div class="status-order-stepper-item">
              <div class="status-order-stepper-icon">
                <svg v-if="shipperDelivered" width="15" height="11" viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.16631 8.28722L2.14773 5.26864L0.851562 6.5648L5.16631 10.8796L14.0644 1.98147L12.7682 0.685303L5.16631 8.28722Z" fill="#0078CE" />
                </svg>
                <svg v-else width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M7.76208 7.85927C7.61237 7.94862 7.43734 7.99996 7.25033 7.99996H5.50033H1.91699C1.36471 7.99996 0.916992 7.55224 0.916992 6.99996V1.66663C0.916992 1.11434 1.36471 0.666626 1.91699 0.666626H7.25033C7.80261 0.666626 8.25033 1.11434 8.25033 1.66663V6.16664H10.0837C10.6945 6.16664 11.2364 6.46677 11.5698 6.92735C11.9408 7.4401 12.4301 7.99997 13.063 7.99997C13.311 7.99997 13.5523 7.91953 13.7507 7.77073L16.1337 5.98334C16.1706 5.95561 16.209 5.9311 16.2485 5.90976L15.9503 4.82829C15.874 4.56203 15.6561 4.33329 15.3791 4.33329H15.2738C14.9387 4.33329 14.667 4.0616 14.667 3.72646V3.41663C14.667 2.91037 15.0774 2.49996 15.5837 2.49996H16.1914C17.0333 2.49996 17.7158 3.18246 17.7158 4.02438V4.11484C17.7158 4.25981 17.7353 4.40413 17.7739 4.5439L17.9871 5.31772C18.094 5.27404 18.211 5.24996 18.3337 5.24996C18.8399 5.24996 19.2503 5.66037 19.2503 6.16663C19.2503 6.62624 18.9121 7.00685 18.4709 7.07309L18.9133 8.67815C18.952 8.81868 18.9558 8.96059 18.9299 9.09464C20.1826 9.53179 21.0837 10.7251 21.0837 12.125C21.0837 13.8941 19.6445 15.3333 17.8753 15.3333C16.5798 15.3333 15.4613 14.5616 14.9552 13.4537C14.8646 13.4837 14.7677 13.5 14.667 13.5H8.85722C8.34141 14.583 7.23605 15.3333 5.95866 15.3333C4.18949 15.3333 2.75033 13.8941 2.75033 12.125C2.75033 10.8476 3.50061 9.74221 4.58366 9.2264V8.91663C4.58366 8.41037 4.99406 7.99996 5.50033 7.99996C6.00659 7.99996 6.41699 8.41037 6.41699 8.91663V8.94926C7.8201 9.15079 8.93282 10.2635 9.13436 11.6666H14.667C14.6779 11.6666 14.6887 11.6668 14.6995 11.6672C14.8856 10.3702 15.8503 9.32116 17.1033 9.01051L16.7691 7.79832L14.5889 9.43335C14.2427 9.69296 13.8217 9.8333 13.389 9.8333H11.917C11.3882 9.8333 10.9111 9.60844 10.5763 9.24929C10.543 9.21361 10.5094 9.17735 10.4755 9.14074L10.4754 9.14063C9.98175 8.60749 9.41921 7.99997 8.70866 7.99997H8.25033C8.07086 7.99997 7.90345 7.9484 7.76208 7.85927ZM3.75033 6.16663C3.19804 6.16663 2.75033 5.71891 2.75033 5.16663V3.49996C2.75033 2.94767 3.19804 2.49996 3.75033 2.49996H5.41699C5.96928 2.49996 6.41699 2.94768 6.41699 3.49996V5.16663C6.41699 5.71891 5.96928 6.16663 5.41699 6.16663H3.75033ZM4.58366 12.125C4.58366 11.3669 5.20058 10.75 5.95866 10.75C6.71674 10.75 7.33366 11.3669 7.33366 12.125C7.33366 12.883 6.71674 13.5 5.95866 13.5C5.20058 13.5 4.58366 12.883 4.58366 12.125ZM16.5003 12.125C16.5003 11.3669 17.1172 10.75 17.8753 10.75C18.6334 10.75 19.2503 11.3669 19.2503 12.125C19.2503 12.883 18.6334 13.5 17.8753 13.5C17.1172 13.5 16.5003 12.883 16.5003 12.125Z" :fill="shipperDelivery ? '#0078CE' : '#767676'" />
                </svg>
              </div>
              <div :class="['status-order-stepper-text', { 'ol-brand': shipperDelivery }]">
                {{ $t('v2.in_delivery') }}
              </div>
            </div>
            <hr :class="['line-order-stepper', { 'olbrand': shipperDelivered }]">
            <div class="status-order-stepper-item">
              <div class="status-order-stepper-icon">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.9167 15.4166V9.02307C9.9167 8.84182 9.96596 8.66399 10.0592 8.50857L11.9644 5.33332H5.50171C5.15044 5.33332 4.82492 5.51763 4.6442 5.81885L2.72582 9.0164C2.63259 9.17181 2.58333 9.34963 2.58333 9.53087V14.4166C2.58333 14.9689 3.03105 15.4166 3.58333 15.4166H9.9167ZM12.6633 3.49998H5.33679C5.37915 2.9867 5.80915 2.58333 6.33337 2.58333H11.6667C12.1909 2.58333 12.6209 2.9867 12.6633 3.49998ZM14.5 4.16172V1.75C14.5 1.19772 14.0523 0.75 13.5 0.75H4.50003C3.94775 0.75 3.50003 1.19772 3.50003 1.75V3.95833C3.50003 4.01866 3.50586 4.07762 3.51698 4.1347L0.89252 8.50855C0.799263 8.66397 0.75 8.84181 0.75 9.02306V16.25C0.75 16.8023 1.19772 17.25 1.75 17.25H16.25C16.8023 17.25 17.25 16.8023 17.25 16.25V9.02299C17.25 8.84179 17.2008 8.66398 17.1075 8.50859L14.5 4.16172ZM13.5834 6.19826L11.8925 9.01641C11.7993 9.17182 11.75 9.34966 11.75 9.5309V15.4166H14.4167C14.969 15.4166 15.4167 14.9689 15.4167 14.4166V9.53087C15.4167 9.34963 15.3674 9.17181 15.2742 9.0164L13.5834 6.19826Z" :fill="shipperDelivered ? '#0078CE' : '#767676'" />
                </svg>
              </div>
              <div :class="['status-order-stepper-text', { 'ol-brand': shipperDelivered }]">
                {{ $t('v2.received') }}
              </div>
            </div>
            <!-- <div class="detail-status primary--text font-weight-bold">
              <v-icon v-if="shipperProcess" small color="primary" class="mr-1">
                mdi-check-circle
              </v-icon>
              Diproses
            </div>
            <hr :class="[`line-horizontal`, { 'primary': outForDelivery }]">
            <div :class="[`detail-status`, { 'primary--text font-weight-bold': outForDelivery }]">
              <v-icon v-if="outForDelivery" small color="primary" class="mr-1">
                mdi-check-circle
              </v-icon>
              Dikirim
            </div>
            <hr :class="[`line-horizontal`, { 'primary': isDelivered }]">
            <div :class="['detail-status', { 'primary--text font-weight-bold': isDelivered }]">
              <v-icon v-if="isDelivered" small color="primary" class="mr-1">
                mdi-check-circle
              </v-icon>
              Diterima
            </div> -->
          </div>
          <div class="pa-4 ol-elevation-2 br-8 mb-4">
            <div class="flex-image">
              <div v-if="!$isEmpty(order.logo)" class="flex-image-avatar mr-4">
                <img :src="order.logo.original" :alt="order.store_name" class="image-80">
              </div>
              <div class="flex-image-content">
                <div class="flex-image-content-text font-18 font-weight-700 mb-1">
                  {{ order.store_name }}
                </div>
                <div class="flex-image-content-text font-14 font-weight-400 mb-1">
                  <span v-mask-money="order.total_amount" />
                </div>
                <div class="flex-image-content-text">
                  <div :class="['status-order', { 'status-pending': order.status_inquiry === 1, 'status-confirm': order.status_inquiry === 2, 'status-ready': order.status_inquiry === 3 || order.status_inquiry === 4 , 'status-done': order.status_inquiry === 5, 'status-failed': order.status_inquiry === 6 || order.status_inquiry === 7 }]">
                    {{ order.status_desc }}
                  </div>
                </div>
              </div>
              <div v-if="order.status_inquiry !== 1 && order.status_inquiry !== 2 && order.status_inquiry !== 5" class="ml-4 align-self-center">
                <v-btn width="24" height="24" icon color="#1FAD1F" :href="'https://wa.me/' + order.store_setting_whatsapp">
                  <v-icon>
                    mdi-whatsapp
                  </v-icon>
                </v-btn>
              </div>
            </div>
            <div v-if="order.notes" class="mt-4">
              <div class="text-order-notes">
                {{ order.notes }}
              </div>
            </div>
            <template v-if="(!$isEmpty(order.payment_log) && order.payment_mode_id !== 10 && order.is_paid !== 1)">
              <div class="div-line my-4" />
              <div class="flex-image">
                <div v-if="order.payment_log.payment_type !== 'QRIS'" class="flex-image-avatar mr-4">
                  <img :src="order.payment_log.payment_image" :alt="order.payment_log.payment_source === 'VIRTUAL-ACCOUNT' ? order.payment_log.va_bank_code : order.payment_log.payment_type" class="image-40">
                </div>
                <div v-else-if="order.payment_log.payment_type === 'QRIS' && formattedTimeLeft !== 'EXPIRED'" class="flex-image-avatar mr-4">
                  <img :src="order.payment_log.qr_image" :alt="order.payment_log.payment_source" class="image-40" @click="dialog.qris_image = true">
                </div>
                <div class="flex-image-content">
                  <template v-if="order.payment_log.payment_source === 'VIRTUAL-ACCOUNT' && formattedTimeLeft !== 'EXPIRED'">
                    <div class="flex-image-content-text font-14 font-weight-600">
                      {{ order.payment_log.va_account_number }}
                    </div>
                    <div class="flex-image-content-text font-12 font-weight-400">
                      {{ order.payment_log.va_bank_code }}
                    </div>
                    <input id="va_account_number" type="hidden" :value="order.payment_log.va_account_number">
                  </template>
                  <div v-else-if="order.payment_log.payment_source === 'VIRTUAL-ACCOUNT' && formattedTimeLeft === 'EXPIRED'" class="flex-image-content-text font-14 font-weight-600">
                    Bank {{ order.payment_log.va_bank_code }}
                  </div>
                  <div v-else class="flex-image-content-text font-14 font-weight-600">
                    {{ order.payment_log.payment_type }}
                  </div>
                </div>
                <v-btn v-if="order.payment_log.payment_source === 'VIRTUAL-ACCOUNT' && formattedTimeLeft !== 'EXPIRED'" icon color="olbrand" class="ml-2 mirror" @click="copyText()">
                  <v-icon>
                    mdi-content-copy
                  </v-icon>
                </v-btn>
                <v-btn v-else-if="order.payment_log.payment_type === 'QRIS' && formattedTimeLeft !== 'EXPIRED'" text color="olbrand" class="ml-2 font-16 font-weight-700 text-none letter-spacing-normal" @click="dialog.qris_image = true">
                  {{ $t('v2.view_qr') }}
                </v-btn>
              </div>
              <div class="div-line my-4" />
              <div :class="['d-flex align-center', { 'mb-4': order.payment_log.payment_source !== 'E-WALLET' }]">
                <div class="font-14 ol-black">
                  {{ $t('v2.total') }}
                </div>
                <v-spacer />
                <div class="font-14 font-weight-600">
                  <span v-mask-money="order.total_amount" />
                </div>
              </div>
              <template v-if="order.payment_log.payment_source !== 'E-WALLET'">
                <div class="qris-countdown mb-4">
                  <div class="qris-countdown-icon">
                    <img src="@/assets/images/v2/img/icon_warning.png" alt="Warning">
                  </div>
                  <div class="qris-countdown-content">
                    <template v-if="formattedTimeLeft !== '00:00' && formattedTimeLeft !== 'EXPIRED'">
                      <div v-if="order.payment_log.expired_at" class="qris-countdown-title four-line" v-html="$t('v2.immediately_pay_for_order_in2', { time: formattedTimeLeft === 'EXPIRED' ? '00:00' : formattedTimeLeft })" />
                      <div v-else class="qris-countdown-title four-line" v-html="$t('v2.immediately_pay_for_order_in3')" />
                    </template>
                    <div v-else class="qris-countdown-title four-line" v-html="$t('v2.your_payment_time_has_expired')" />
                  </div>
                </div>
                <v-btn v-if="order.payment_log.payment_source !== 'E-WALLET' && formattedTimeLeft !== '00:00' && formattedTimeLeft !== 'EXPIRED'" block color="olbrand" outlined height="40" class="mb-2 br-5 font-16 font-weight-700 text-none letter-spacing-normal" @click="(dialog.payment_guide = true)">
                  {{ $t('v2.payment_guide') }}
                </v-btn>
              </template>
            </template>
            <div v-if="(order.status_inquiry === 3 || order.status_inquiry === 4) && order.remark === 'OL-DINE-IN' && $store.state.selected_store.setting.enable_online_chat !== 0" class="mt-4">
              <v-btn color="olbrand" block height="40" class="text-none white--text br-5 font-weight-700 ol-elevation-1 letter-spacing-normal" @click="showDialogCallWaiter()">
                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-2">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M17.4167 1.8335H18.3333C19.3444 1.8335 20.1667 2.65575 20.1667 3.66683V4.5835V6.41683V11.0002C20.1667 12.0112 19.3444 12.8335 18.3333 12.8335V11.0002V6.79633V5.50016C18.3333 4.48908 17.5111 3.66683 16.5 3.66683H15.2038H5.5C5.5 2.65575 6.32225 1.8335 7.33334 1.8335H15.5815H17.4167ZM4.58334 19.9523V16.5002H3.66667C2.65559 16.5002 1.83334 15.6779 1.83334 14.6668V7.3335C1.83334 6.32241 2.65559 5.50016 3.66667 5.50016H14.6667C15.6778 5.50016 16.5 6.32241 16.5 7.3335V14.6668C16.5 15.6779 15.6778 16.5002 14.6667 16.5002H10.3373L5.97209 19.1191L4.58334 19.9523ZM14.6667 7.3335H3.66667V14.6668H6.41667V16.7147L9.82942 14.6668H14.6667V7.3335Z" fill="white" />
                </svg>
                {{ $t('v2.call_waiter') }}
              </v-btn>
            </div>
          </div>

          <div class="pa-4 ol-elevation-2 br-8">
            <div>
              <div class="d-flex align-center">
                <div>
                  <div class="font-12 font-weight-400 ol-grey-content">
                    {{ $t('v2.order_number') }}
                  </div>
                  <div class="font-18 font-weight-700">
                    {{ order.order_no }}
                  </div>
                </div>
                <v-spacer />
                <div v-if="order.remark === 'OL-DINE-IN'" class="d-flex align-center">
                  <div class="wrap-table">
                    <div class="wrap-table-icon">
                      <img :src="icon_table" :alt="$t('table')">
                    </div>
                    <div class="wrap-table-content">
                      <div class="wrap-table-text">
                        {{ $t('table') }} {{ order.table_no }}
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else-if="order.remark === 'OL-TAKE-AWAY'" class="d-flex align-center">
                  <div class="wrap-table">
                    <div class="wrap-table-icon">
                      <img :src="require('@/assets/images/v2/img/icon_take_away.png')" :alt="$t('v2.takeaway')">
                    </div>
                    <div class="wrap-table-content">
                      <div class="wrap-table-text">
                        {{ $t('v2.takeaway') }}
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else-if="order.remark === 'DELIVERY'" class="d-flex align-center">
                  <div class="wrap-table">
                    <div class="wrap-table-icon">
                      <img :src="require('@/assets/images/v2/img/icon-side-delivery.png')" :alt="$t('v2.delivery')">
                    </div>
                    <div class="wrap-table-content">
                      <div class="wrap-table-text">
                        {{ $t('v2.delivery') }}
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else-if="order.remark === 'RESERVATION'" class="d-flex align-center">
                  <div class="wrap-table">
                    <div class="wrap-table-icon">
                      <img :src="icon_side_reservation" :alt="order.remark">
                    </div>
                    <div class="wrap-table-content">
                      <div class="wrap-table-text">
                        {{ order.remark }}
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else-if="order.remark === 'DELIVERY'" class="d-flex align-center">
                  <div class="wrap-table">
                    <div class="wrap-table-icon">
                      <img :src="icon_side_delivery" :alt="order.remark">
                    </div>
                    <div class="wrap-table-content">
                      <div class="wrap-table-text">
                        {{ $t('v2.delivery') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="div-line my-4" />
            <div>
              <div class="d-flex align-center">
                <div class="font-14 font-weight-400">
                  {{ $t('v2.date') }}
                </div>
                <v-spacer />
                <div class="font-14 font-weigth-600">
                  {{ order.forder_date }}, {{ order.forder_time }}
                </div>
              </div>
            </div>
          </div>

          <div v-if="order.remark === 'DELIVERY'" class="pa-4 ol-elevation-2 br-8 mt-4">
            <div class="font-18 font-weight-700 mb-2">
              {{ $t('v2.deliveryv2') }}
            </div>
            <div>
              <div class="flex-image grid py-2">
                <div class="icon-40 br-5 bg-orange-soft mr-2">
                  <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.148 0.971C16.789 0.372 16.132 0 15.434 0H4.566C3.868 0 3.211 0.372 2.852 0.971L0.143 5.485C0.0489999 5.641 0 5.818 0 6C0 7.006 0.386 7.914 1 8.618V17C1 18.103 1.897 19 3 19H7H13H17C18.103 19 19 18.103 19 17V8.618C19.614 7.914 20 7.006 20 6C20 5.818 19.951 5.641 19.857 5.485L17.148 0.971ZM17.984 6.251C17.86 7.235 17.018 8 16 8C14.897 8 14 7.103 14 6C14 5.932 13.975 5.872 13.961 5.808L13.981 5.804L13.22 2H15.434L17.984 6.251ZM8.819 2H11.18L11.993 6.065C11.958 7.137 11.08 8 10 8C8.92 8 8.042 7.137 8.007 6.065L8.819 2ZM4.566 2H6.78L6.02 5.804L6.04 5.808C6.025 5.872 6 5.932 6 6C6 7.103 5.103 8 4 8C2.982 8 2.14 7.235 2.016 6.251L4.566 2ZM8 17V14H12V17H8ZM14 17V14C14 12.897 13.103 12 12 12H8C6.897 12 6 12.897 6 14V17H3V9.858C3.321 9.941 3.652 10 4 10C5.193 10 6.267 9.475 7 8.643C7.733 9.475 8.807 10 10 10C11.193 10 12.267 9.475 13 8.643C13.733 9.475 14.807 10 16 10C16.348 10 16.679 9.941 17 9.858V17H14Z" fill="#F0820A" />
                  </svg>
                </div>
                <div class="flex-image-content">
                  <div class="flex-image-content-text font-14 font-weight-600 ol-black two-line">
                    {{ order.store_name }}
                  </div>
                </div>
                <span class="stepper-line" />
              </div>
              <div class="flex-image py-2">
                <div class="icon-40 br-5 bg-orange-soft mr-2">
                  <svg width="17" height="21" viewBox="0 0 17 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.18164 20.498C6.7059 19.4612 5.3361 18.2815 4.0918 16.976C2.99701 15.8471 2.0524 14.582 1.28027 13.212C0.480429 11.8334 0.0405756 10.2754 0.00195312 8.68201C0.00459997 6.51264 0.867302 4.43293 2.40137 2.89905C3.93543 1.36517 6.01521 0.502382 8.18457 0.5C10.3538 0.502382 12.4339 1.3652 13.9678 2.89911C15.5017 4.43302 16.3648 6.51274 16.3672 8.68201C16.3286 10.2754 15.8887 11.8334 15.0889 13.212C14.3167 14.582 13.3721 15.8471 12.2773 16.976C11.0335 18.2817 9.66401 19.4613 8.18848 20.498H8.18164ZM8.18164 5.95398C7.45855 5.95477 6.76531 6.24233 6.25391 6.75354C5.74251 7.26475 5.45516 7.95794 5.4541 8.68103C5.45516 9.40412 5.74251 10.0972 6.25391 10.6085C6.76531 11.1197 7.45855 11.4072 8.18164 11.408C8.90438 11.407 9.59753 11.1192 10.1084 10.608C10.6193 10.0967 10.9067 9.40377 10.9072 8.68103C10.9067 7.95847 10.619 7.26561 10.1084 6.75439C9.59775 6.24318 8.90518 5.9553 8.18262 5.95398H8.18164Z" fill="#F5295A" />
                  </svg>
                </div>
                <div class="flex-image-content">
                  <div class="flex-image-content-text font-14 font-weight-600 ol-black one-line">
                    {{ shippingDetail.name }}
                  </div>
                  <div class="flex-image-content-text font-12 font-weight-400 ol-grey-content">
                    {{ shippingDetail.detail }}
                  </div>
                </div>
              </div>
            </div>
            <template v-if="!$isEmpty(driverDetail) && typeof driverDetail.name !== 'undefined' && driverDetail.name !== '' && (order.status === 'A' || order.status === 'S')">
              <div class="div-line my-4" />
              <div class="flex-image py-2">
                <div class="d-flex align-center justify-center mr-2">
                  <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg" :class="['avatar-driver', { 'gojek': order.shipping_delivery_type === '2' && order.shipping_courier_id === 'S08', 'grab': order.shipping_delivery_type === '2' && order.shipping_courier_id === 'S09' }]">
                    <g clip-path="url(#clip0_4698_7915)">
                      <rect y="0.5" width="40" height="40" rx="20" fill="white" />
                      <mask id="mask0_4698_7915" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="40" height="41">
                        <rect y="0.5" width="40" height="40" rx="20" fill="white" />
                      </mask>
                      <g mask="url(#mask0_4698_7915)">
                        <path class="avatar-driver-p1" fill-rule="evenodd" clip-rule="evenodd" d="M25.3421 43.4688C25.3421 43.4688 23.7476 36.7802 26.6716 33.7747C27.802 32.6128 29.0005 32.0001 30.0005 32.7693C31.5005 34.0001 32.8513 35.3808 33.4288 37.8988C34.0136 42.7322 33.5247 48.5113 33.9633 53.6266C34.1278 55.5181 34.6441 59.4421 35.0004 62.1612C33.5247 62.4476 29.7098 63.1842 29.8378 63.1433L29.8149 63.6389C29.0154 61.0472 27.8869 56.9959 27.0737 52.9218C26.0731 47.8293 25.3421 43.4688 25.3421 43.4688Z" fill="#1FAD1F" />
                        <path class="avatar-driver-p2" fill-rule="evenodd" clip-rule="evenodd" d="M19.6085 29.6824L17.21 29.1277C17.21 29.1277 10.5003 32.0001 9.00024 33.0001C7.50022 34.0001 8.66187 34.2521 8.48369 34.4021C8.38637 34.63 8.35321 34.8799 8.38775 35.1251C8.38775 35.2842 8.38774 35.4707 8.41059 35.6798C8.92228 47.4245 11.0696 54.6178 11.4442 68.1085C18.4252 69.2134 23.6564 68.9452 30.8567 68.0449C30.8567 68.0449 31.5329 50.521 31.606 47.6291C31.6791 44.7373 31.638 46.5197 31.6608 45.965C31.7476 43.2368 32.3155 37.7552 32.0002 36.0001C31.5002 34.0001 30.0029 32.7731 29.9978 32.7698C28.5002 31.5001 25.9995 30.6845 24.1498 29.3778L23.7341 29.7415C22.3616 29.6343 20.9836 29.6145 19.6085 29.6824Z" fill="#1FAD1F" />
                        <path class="avatar-driver-p3" fill-rule="evenodd" clip-rule="evenodd" d="M17.4792 25.7583L17.2142 29.1276C17.2142 29.1276 17.1457 30.9464 18.8909 32.7651C20.6362 34.5839 23.2678 34.0746 23.9577 32.3559C24.6475 30.6372 24.2044 29.7641 24.2044 29.7641L23.4734 26.845L17.4792 25.7583Z" fill="#FDCC98" />
                        <path class="avatar-driver-p4" fill-rule="evenodd" clip-rule="evenodd" d="M17.479 25.7583L17.2734 28.3591C18.6727 29.291 20.3465 29.7266 22.0249 29.5959C22.7177 29.5401 23.3991 29.387 24.0489 29.1412L23.4732 26.8405L17.479 25.7583Z" fill="#D7A26B" />
                        <path class="avatar-driver-p5" fill-rule="evenodd" clip-rule="evenodd" d="M27.5803 13.4407C27.5803 13.4407 27.8818 19.5791 26.4975 23.6577C25.1132 27.7363 24.1263 28.8912 20.3343 28.0318C16.5422 27.1725 14.6965 23.0984 14.6965 23.0984C14.6965 23.0984 12.54 23.9578 11.4664 22.1117C10.3927 20.2657 11.4207 18.4196 12.2385 18.3787C12.3326 18.3675 12.4277 18.3675 12.5218 18.3787C13.0827 18.4578 13.6158 18.6716 14.0751 19.0016C13.7479 17.5426 13.843 16.0212 14.3492 14.6138C14.3492 14.6138 14.2899 10.9763 16.7478 10.1397C19.2058 9.30302 21.9242 10.1397 21.9242 10.1397C21.9242 10.1397 21.9562 10.3852 21.9973 10.7126L27.16 10.8717C27.499 11.6838 27.6429 12.5635 27.5803 13.4407Z" fill="#FDCC98" />
                        <path class="avatar-driver-p6" fill-rule="evenodd" clip-rule="evenodd" d="M24.9993 19.8848C25.1778 19.9228 25.3635 19.9042 25.531 19.8318C25.6985 19.7593 25.8395 19.6365 25.9346 19.4803C26.0297 19.324 26.0741 19.142 26.0618 18.9594C26.0495 18.7767 25.9811 18.6024 25.866 18.4604C25.7508 18.3184 25.5947 18.2158 25.419 18.1666C25.2433 18.1174 25.0567 18.1241 24.885 18.1858C24.7132 18.2475 24.5648 18.3611 24.4601 18.511C24.3554 18.6609 24.2995 18.8397 24.3003 19.0227C24.2811 19.2297 24.3435 19.436 24.4742 19.5972C24.605 19.7584 24.7935 19.8617 24.9993 19.8848Z" fill="#272727" />
                        <path class="avatar-driver-p7" fill-rule="evenodd" clip-rule="evenodd" d="M19.7024 19.9507C19.8809 19.9887 20.0667 19.9701 20.2342 19.8977C20.4017 19.8252 20.5427 19.7024 20.6377 19.5462C20.7328 19.3899 20.7772 19.208 20.7649 19.0253C20.7526 18.8426 20.6842 18.6683 20.5691 18.5263C20.4539 18.3843 20.2978 18.2817 20.1221 18.2325C19.9464 18.1833 19.7598 18.19 19.5881 18.2517C19.4164 18.3134 19.2679 18.427 19.1632 18.5769C19.0585 18.7268 19.0027 18.9056 19.0034 19.0887C18.9842 19.2956 19.0466 19.5019 19.1774 19.6631C19.3081 19.8243 19.4966 19.9276 19.7024 19.9507Z" fill="#272727" />
                        <path class="avatar-driver-p8" fill-rule="evenodd" clip-rule="evenodd" d="M21.0659 15.7733L20.9791 16.3916C20.028 16.3858 19.0816 16.5269 18.1739 16.81L18.1328 16.0097C18.1328 16.0097 19.9101 15.314 21.0659 15.7733Z" fill="#272727" />
                        <path class="avatar-driver-p9" fill-rule="evenodd" clip-rule="evenodd" d="M23.7695 15.6049V16.3006C24.6108 16.2766 25.4465 16.4429 26.2138 16.7871L26.4834 16.1232C25.6516 15.683 24.7059 15.5024 23.7695 15.6049Z" fill="#272727" />
                        <path class="avatar-driver-p10" fill-rule="evenodd" clip-rule="evenodd" d="M24.602 23.2303C23.3662 23.4755 22.097 23.5048 20.8511 23.3167C18.8911 22.9939 18.4571 22.5437 18.4571 22.5437C18.4571 22.5437 17.3789 24.9263 20.3531 25.7266C23.3273 26.5268 24.5609 25.14 24.602 23.2303Z" fill="#CB3638" />
                        <path class="avatar-driver-p11" fill-rule="evenodd" clip-rule="evenodd" d="M24.5147 23.2484C23.309 23.4767 22.0731 23.4998 20.8597 23.3166C19.3155 23.0619 18.717 22.73 18.5342 22.5981C18.4931 22.9028 18.589 23.403 19.416 23.9395C20.7409 24.7989 23.5781 24.7352 24.236 23.7894C24.3528 23.6223 24.4465 23.4403 24.5147 23.2484Z" fill="white" />
                        <path class="avatar-driver-p12" fill-rule="evenodd" clip-rule="evenodd" d="M22.7698 19.7019C22.8096 20.0435 22.9371 20.3692 23.1399 20.6477C23.5145 21.266 23.4825 21.8026 23.0713 22.1391C22.7566 22.3422 22.3772 22.4216 22.0068 22.3619C22.2578 22.4477 22.525 22.476 22.7885 22.4445C23.0519 22.413 23.3048 22.3226 23.5282 22.18C24.1313 21.6844 23.615 20.7522 23.2998 20.3339C23.1386 20.1109 22.9615 19.8997 22.7698 19.7019Z" fill="#D7A26B" />
                        <path class="avatar-driver-p13" fill-rule="evenodd" clip-rule="evenodd" d="M12.2524 19.4927C12.5472 19.554 12.8211 19.69 13.0476 19.8876C13.2742 20.0851 13.4456 20.3375 13.5454 20.6203C13.6432 20.8902 13.6739 21.1796 13.6349 21.4639C13.5959 21.7481 13.4884 22.0187 13.3215 22.2527C13.3215 22.2527 12.5722 22.4527 12.1702 21.2342C12.1702 21.2342 13.0611 21.3387 13.0611 20.9431C13.0611 20.5476 12.0057 20.3475 12.0012 20.3475C11.9817 20.1955 11.994 20.0411 12.0372 19.894C12.0805 19.7469 12.1537 19.6103 12.2524 19.4927Z" fill="#D7A26B" />
                        <path class="avatar-driver-p14" fill-rule="evenodd" clip-rule="evenodd" d="M11.9233 16.1553C11.9918 16.469 12.074 16.7873 12.17 17.1056C12.3063 17.523 12.4176 17.9482 12.5035 18.3787C13.0644 18.4578 13.5975 18.6716 14.0569 19.0016C14.1745 19.1314 14.2591 19.2873 14.3036 19.4563C14.3238 19.5538 14.3375 19.6526 14.3447 19.7519L14.966 19.8383C14.8703 19.3442 14.835 18.8403 14.861 18.3378C14.8748 17.8163 15.0683 17.3154 15.4092 16.9191C15.4092 16.9191 16.0077 16.7782 16.4417 14.8685C16.6707 13.5628 16.5638 12.2207 16.1311 10.9672L17.1956 11.1764L18.1504 11.5219C19.7936 11.8197 21.4601 11.9719 23.1303 11.9766C24.3471 12.0077 25.5629 11.8855 26.7488 11.6129C27.0133 12.113 27.2261 12.6386 27.3838 13.1816C27.4885 13.5288 27.5604 13.885 27.5986 14.2455V15.2731C27.5986 15.4414 27.5986 15.6187 27.5986 15.7688C27.5986 16.2826 27.5711 16.6781 27.5711 16.6781L27.8955 15.7688C28.1566 14.5745 28.2214 13.3461 28.0874 12.1312C28.0235 11.5901 27.9595 11.1627 27.9001 10.8353C27.8403 10.7103 27.7732 10.5888 27.6991 10.4716C26.8584 9.13933 25.6066 7.67977 21.8785 7.05684C18.1504 6.43391 14.9341 7.89348 14.1391 8.75285C13.3441 9.61222 12.9741 10.0851 12.9741 10.0851C12.9741 10.0851 12.3253 10.4716 11.8502 12.2722C11.586 13.5606 11.6109 14.8912 11.9233 16.1689V16.1553Z" fill="#272727" />
                        <path class="avatar-driver-p15" fill-rule="evenodd" clip-rule="evenodd" d="M11.5993 32.6607C11.8406 32.6828 12.0802 32.7208 12.3166 32.7744C12.8191 34.2203 13.6004 36.5211 14.144 38.2853C12.5359 40.927 8.4377 43.5643 8.4377 43.5643L1.64858 48.2476L6.61936 52.7945L3.81873 56.9686C0.689152 54.5496 -3.86587 50.9167 -4.63341 49.7617C-5.93093 47.8338 -3.51408 45.3012 -1.59521 42.8549C0.433123 40.2627 4.13543 36.0764 8 33.4999C9.5 32.4999 10.6236 32.6299 11.5993 32.6607Z" fill="#1FAD1F" />
                        <path class="avatar-driver-p16" fill-rule="evenodd" clip-rule="evenodd" d="M11.5439 15.7824C11.617 14.3274 11.7587 10.5762 12.0785 10.0442C12.3983 9.51222 14.3903 6.96139 16.9899 6.14749C19.5895 5.33359 22.6825 5.2381 24.5008 6.18386C26.3192 7.12962 27.9502 8.87565 27.9502 9.44401C27.9502 10.0124 28.5213 14.2774 28.5213 14.2774C28.5213 14.2774 21.5083 14.4184 17.8442 14.773C15.7231 14.9633 13.6179 15.3006 11.5439 15.7824Z" fill="#178217" />
                        <path class="avatar-driver-p17" fill-rule="evenodd" clip-rule="evenodd" d="M20.5631 5.52446C21.9102 5.4209 23.2624 5.64726 24.5013 6.18376C26.3288 7.09315 27.9507 8.87555 27.9507 9.44391C27.9507 10.0123 28.5218 14.2773 28.5218 14.2773C28.5218 14.2773 21.5088 14.4183 17.8447 14.7729C16.5198 14.9002 15.3319 15.073 14.3496 15.2276C14.4227 13.1497 14.578 10.0577 14.907 9.59396C15.405 8.87554 17.2188 6.00188 20.5631 5.52446Z" fill="#178217" />
                        <path class="avatar-driver-p18" fill-rule="evenodd" clip-rule="evenodd" d="M16.1771 14.1818C15.5389 14.4741 14.9275 14.821 14.3496 15.2185C14.3496 15.2185 19.7179 15.7096 21.7601 15.7733C23.8023 15.8369 23.5876 14.6865 27.0826 14.3319C28.4115 14.1382 29.7683 14.3374 30.9843 14.9048C31.327 15.1139 31.6285 15.2867 31.7702 15.3595C31.8889 15.4231 31.9758 15.4595 32.0306 15.4368C32.1768 15.4368 32.1494 15.3049 32.1357 15.2367C32.122 15.1685 31.5143 14.0409 29.5954 13.2133C27.6766 12.3858 25.4196 11.8993 21.7464 12.5086C18.0731 13.1178 16.1771 14.1818 16.1771 14.1818Z" fill="#1FAD1F" />
                      </g>
                    </g>
                    <rect class="avatar-driver-r1" x="1" y="1.5" width="38" height="38" rx="19" stroke="#1FAD1F" stroke-width="2" />
                    <defs>
                      <clipPath id="clip0_4698_7915">
                        <rect y="0.5" width="40" height="40" rx="20" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div class="flex-image-content">
                  <div class="flex-image-content-text font-14 font-weight-600 ol-black one-line">
                    {{ driverDetail.name }}
                  </div>
                  <div class="flex-image-content-text font-12 font-weight-400 ol-grey-content">
                    {{ driverDetail.vehicle_number }} - {{ driverDetail.vehicle_type }}
                  </div>
                  <!-- v-if="order.shipping_log && $isEmpty(order.shipping_log) && order.shipping_log.shipper && $isEmpty(order.shipping_log.shipper) && order.shipping_log.shipper.live_tracking" -->
                  <div class="flex-image-content-text font-16 font-weight-700 ol-brand cursor-pointer" @click="openTracking">
                    {{ $t('v2.track_location') }}
                  </div>
                </div>
                <div class="ml-2">
                  <v-btn text icon :href="'tel:' + driverDetail.phone">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M15.7073 10.793C15.3163 10.402 14.6843 10.402 14.2933 10.793L12.6993 12.387C11.9603 12.167 10.5813 11.667 9.70733 10.793C8.83333 9.91901 8.33333 8.54001 8.11333 7.80101L9.70733 6.20701C10.0983 5.81601 10.0983 5.18401 9.70733 4.79301L5.70733 0.793006C5.31633 0.402006 4.68433 0.402006 4.29333 0.793006L1.58133 3.50501C1.20133 3.88501 0.987334 4.40701 0.995334 4.94001C1.01833 6.36401 1.39533 11.31 5.29333 15.208C9.19133 19.106 14.1373 19.482 15.5623 19.506C15.5673 19.506 15.5853 19.506 15.5903 19.506C16.1183 19.506 16.6173 19.298 16.9953 18.92L19.7073 16.208C20.0983 15.817 20.0983 15.185 19.7073 14.794L15.7073 10.793ZM15.5803 17.505C14.3323 17.484 10.0623 17.149 6.70733 13.793C3.34133 10.427 3.01533 6.14201 2.99533 4.91901L5.00033 2.91401L7.58633 5.50001L6.29333 6.79301C6.05433 7.03101 5.95233 7.37501 6.02133 7.70501C6.04533 7.82001 6.63233 10.547 8.29233 12.207C9.95233 13.867 12.6793 14.454 12.7943 14.478C13.1273 14.549 13.4683 14.446 13.7063 14.207L15.0003 12.914L17.5863 15.5L15.5803 17.505Z" fill="#0078CE" />
                    </svg>
                  </v-btn>
                </div>
              </div>
            </template>
          </div>

          <div v-if="order.remark === 'RESERVATION'" class="mt-4">
            <div class="pa-4 ol-elevation-2 br-8">
              <div>
                <div>
                  <div class="d-flex justify-space-between">
                    <div class="">
                      <div class="font-12 font-weight-400 ol-grey-content mb-1">
                        {{ $t('v2.reservation_date') }}
                      </div>
                      <div class="font-18 font-weight-700 ol-black">
                        {{ $formatDate(order.reserve_date, true) }}
                      </div>
                    </div>
                    <div>
                      <div class="font-12 font-weight-400 ol-grey-content mb-1">
                        {{ $t('v2.time') }}
                      </div>
                      <div class="font-18 font-weight-700 ol-black">
                        {{ order.freserve_time }}
                      </div>
                    </div>
                    <div>
                      <div class="font-12 font-weight-400 ol-grey-content mb-1">
                        {{ $t('v2.number_of_tables') }}
                      </div>
                      <div class="font-18 font-weight-700 ol-black">
                        {{ order.total_guest }}
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="div-line my-4" />
                <v-btn outlined color="olbrand" block height="40" class="text-none br-5 font-weight-700 font-16" @click="updateReservation()">
                  {{ $t('v2.change') }}
                </v-btn> -->
              </div>
            </div>
          </div>

          <div class="list-item-checkout mt-4">
            <template v-for="(item, idx) in order.items">
              <div v-if="item.note !== 'REDEEMED'" :key="idx" class="container-item-checkout">
                <div class="item-checkout">
                  <div class="item-checkout-qty font-16 font-weight-600 ol-brand mr-2">
                    {{ item.qty }}x
                  </div>
                  <div class="item-checkout-content">
                    <div class="item-checkout-name font-16 font-weight-400 mb-1">
                      {{ item.item_name }} {{ item.item_variant_name ? '(' + item.item_variant_name + ')' : '' }}
                    </div>
                    <div class="item-checkout-text font-14 font-weight-700 mb-3">
                      <span v-mask-money="item.amount" />
                    </div>
                    <div v-if="textAddons(item) !== ''" class="item-checkout-text ol-accent font-12 font-weight-400 mb-1">
                      {{ textAddons(item) }}
                    </div>
                    <div v-if="item.note !== ''" class="item-checkout-text">
                      <div class="d-flex align-center">
                        <div class="mr-1">
                          <v-icon size="18" color="#767676" style="transform: rotate(180deg) scale(-1, 1);">
                            mdi-note-outline
                          </v-icon>
                        </div>
                        <div class="font-12 font-weight 400 ol-grey-content">
                          {{ notTakeaway(item.note) }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="isTakeaway(item.note)" class="align-self-start ml-2">
                    <div class="font-12 font-weight-600 px-2 py-1 br-5 ol-black bg-grey">
                      {{ $t('v2.takeaway') }}
                    </div>
                  </div>
                </div>
                <div class="list-line" />
              </div>
            </template>
          </div>

          <div class="line-low my-4" />
          <div class="list-price">
            <div class="title-list-price">
              {{ $t('v2.price') }}
            </div>
            <div class="list-component-price">
              <!-- subtotal -->
              <div class="list-item-price">
                <div class="list-item-price-title">
                  {{ $t('v2.subtotal') }}
                </div>
                <v-spacer />
                <div v-mask-money-only="order.order_amount" class="list-item-nominal-price" />
              </div>
              <!-- diskon -->
              <div v-if="order.discount_amount > 0" class="list-item-price">
                <div class="list-item-price-title">
                  {{ $t('v2.discount') }}
                  <span v-if="order.discount_voucher_code && order.discount_voucher_code !== ''">
                    ({{ order.discount_voucher_code }})
                  </span>
                </div>
                <v-spacer />
                <div class="list-item-nominal-price ol-accent">
                  -<span v-mask-money-only="order.discount_amount" />
                </div>
              </div>
              <!-- point -->
              <div v-if="!$isEmpty(order.points) && order.points.type === 'D' && Number(order.points.redeemed_amount) > 0" class="list-item-price">
                <div class="list-item-price-title">
                  {{ $t('v2.voucher_point') }}
                </div>
                <v-spacer />
                <div class="list-item-nominal-price ol-accent">
                  -
                  <span v-mask-money-only="order.points.redeemed_amount" />
                </div>
              </div>
              <!-- ongkir -->
              <div v-if="order.remark === 'DELIVERY'" class="list-item-price">
                <div class="list-item-price-title">
                  {{ $t('v2.delivery_fee') }}
                </div>
                <v-spacer />
                <div v-if="Number(order.shipping_cost) > 0" v-mask-money-only="order.shipping_cost" class="list-item-nominal-price" />
                <div v-else class="list-item-nominal-price">
                  Free
                </div>
              </div>
              <!-- fee -->
              <template v-if="order.remark === 'DELIVERY' || order.remark === 'OL-TAKE-AWAY'">
                <div v-if="Number(order.trans_fee_rate) > 0" class="list-item-price">
                  <div class="list-item-price-title">
                    {{ $t('v2.convenience_fee') }} ({{ order.trans_fee_rate * 100 }}%)
                  </div>
                  <v-spacer />
                  <div v-mask-money-only="order.trans_fee_amount" class="list-item-nominal-price" />
                </div>
                <div v-if="Number(order.service_charge_amount) > 0" class="list-item-price">
                  <div class="list-item-price-title">
                    {{ $t('v2.service_charge') }}
                  </div>
                  <v-spacer />
                  <div v-mask-money-only="Math.round((order.service_charge_amount) * 100) / 100" class="list-item-nominal-price" />
                </div>
              </template>
              <template v-else>
                <div v-if="order.remark === 'RESERVATION' && Number(order.trans_fee_amount) > 0" class="list-item-price">
                  <div class="list-item-price-title">
                    {{ $t('v2.convenience_fee') }} ({{ order.trans_fee_rate * 100 }}%)
                  </div>
                  <v-spacer />
                  <div v-mask-money-only="order.trans_fee_amount" class="list-item-nominal-price" />
                </div>
                <div v-if="Number(order.service_charge_amount) > 0" class="list-item-price">
                  <div class="list-item-price-title">
                    {{ $t('v2.service_charge') }}
                  </div>
                  <v-spacer />
                  <div v-mask-money-only="Math.round((order.service_charge_amount) * 100) / 100" class="list-item-nominal-price" />
                </div>
              </template>
              <!-- pajak -->
              <div v-if="Number(order.tax_amount) > 0" class="list-item-price">
                <div class="list-item-price-title">
                  {{ $store.state.selected_outlet.tax_name ? $store.state.selected_outlet.tax_name : $t('v2.tax') }}
                </div>
                <v-spacer />
                <div v-mask-money-only="order.tax_amount" class="list-item-nominal-price" />
              </div>
              <!-- pembulatan -->
              <div v-if="Number(order.rounded_amount) > 0" class="list-item-price">
                <div class="list-item-price-title">
                  {{ $t('v2.rounding') }}
                </div>
                <v-spacer />
                <div v-mask-money-only="order.rounded_amount" class="list-item-nominal-price" />
              </div>
              <div v-else-if="Number(order.rounded_amount) < 0" class="list-item-price">
                <div class="list-item-price-title">
                  {{ $t('v2.rounding') }}
                </div>
                <v-spacer />
                <div v-mask-money-only="order.rounded_amount" class="list-item-nominal-price ol-accent" />
              </div>
            </div>
            <div class="line-dot my-4" />
            <div class="total-price">
              <div class="total-price-title">
                {{ $t('v2.total') }}
              </div>
              <v-spacer />
              <div v-mask-money="order.total_amount" class="total-nominal-price" />
            </div>
            <div v-if="order.payment_mode_id === 10" class="total-price pt-6">
              <div class="total-price-title">
                {{ $t('v2.payment_method') }}
              </div>
              <v-spacer />
              <div class="total-nominal-price">
                {{ $t('v2.pay_at_the_cashier') }}
              </div>
            </div>
            <div v-else-if="!$isEmpty(order.payment_log) && order.payment_log.payment_source === 'VIRTUAL-ACCOUNT'" class="total-price pt-6">
              <div class="total-price-title">
                {{ $t('v2.payment_method') }}
              </div>
              <v-spacer />
              <div class="total-nominal-price">
                BANK {{ order.payment_log.va_bank_code }}
              </div>
            </div>
            <div v-else-if="!$isEmpty(order.payment_log)" class="total-price pt-6">
              <div class="total-price-title">
                {{ $t('v2.payment_method') }}
              </div>
              <v-spacer />
              <div class="total-nominal-price">
                {{ order.payment_log.payment_type }}
              </div>
            </div>
            <div v-else class="total-price pt-6">
              <div class="total-price-title">
                {{ $t('v2.payment_method') }}
              </div>
              <v-spacer />
              <div class="total-nominal-price">
                {{ order.payment_mode_name }}
              </div>
            </div>
            <template v-if="!$isEmpty(order.points) && order.points.earned_points > 0">
              <div class="line-dot my-6" />
              <div class="list-item-price">
                <div class="list-item-price-title">
                  {{ $t('v2.point_earned') }}
                </div>
                <v-spacer />
                <div class="list-item-nominal-price ol-accent">
                  +{{ Number(order.points.earned_points) }} pts
                </div>
              </div>
            </template>
          </div>
          <div class="mt-4">
            <template v-for="(item, idx) in order.items">
              <div v-if="item.note === 'REDEEMED'" :key="idx" class="mb-2">
                <div class="flex-image pa-4 bg-accent-soft br-8">
                  <div class="mr-2">
                    <img src="@/assets/images/v2/img/icon_point.png" alt="Voucher" class="image-22">
                  </div>
                  <div class="flex-image-content">
                    <div class="flex-image-content-text font-14 font-weight-600 ol-black two-line">
                      {{ Number(item.qty) }}x {{ item.item_name }} {{ item.item_variant_name ? '(' + item.item_variant_name + ')' : '' }}
                    </div>
                    <div class="flex-image-content-text font-12 font-weight-400 ol-grey-content">
                      {{ $t('v2.from_point_exchange') }}
                    </div>
                  </div>
                  <div class="font-12 font-weight-400 ol-black ml-2">
                    {{ !$isEmpty(order.points) && order.points.redeemed_amount && Number(order.points.redeemed_amount) ? '-' + Number(order.points.redeemed_points) + ' pts' : '' }}
                  </div>
                </div>
              </div>
            </template>
          </div>
          <div class="mt-10">
            <v-btn v-if="order.status_inquiry === 5" outlined block color="olbrand" height="40" class="br-5 font-weight-700 text-none ol-elevation-1 mb-2 letter-spacing-normal" @click="openSplitBill()">
              {{ $t('v2.split_bill') }}
            </v-btn>
            <v-btn v-if="order.status_inquiry === 5 || order.status_inquiry === 6 || order.status_inquiry === 7" block color="primary" height="40" class="br-5 ol-red font-weight-700 text-none white--text ol-elevation-1 letter-spacing-normal mb-2" @click="reOrder()">
              {{ $t('v2.reorder') }}
            </v-btn>
            <v-btn v-if="formattedTimeLeft !== 'EXPIRED' && formattedTimeLeft !== '00:00' && order.status === 'P' && !$isEmpty(order.payment_log) && order.payment_log.global_status === 'P'" block color="olbrand" height="40" class="br-5 white--text font-weight-700 text-none ol-elevation-1 mb-2 letter-spacing-normal" @click="refreshPage">
              {{ $t('v2.update_payment_status') }}
            </v-btn>
            <v-btn v-if="order.status === 'P' && order.is_paid === 0 && Number(order.total_amount) !== 0 && order.payment_mode_id !== 10" block color="white" height="40" class="br-5 ol-black font-weight-700 text-none ol-elevation-1 mb-2 letter-spacing-normal" @click="changePayment()">
              {{ $t('v2.change_payment_method') }}
            </v-btn>
            <template v-if="order.status === 'P' && order.is_paid === 0">
              <v-btn block color="white" height="40" class="br-5 ol-red font-weight-700 text-none ol-elevation-1 letter-spacing-normal" @click="confirmCancel">
                {{ $t('v2.cancel_order') }}
              </v-btn>
            </template>
          </div>
          <v-bottom-sheet v-model="dialog.payment_guide" content-class="dialog-icon">
            <div class="position-relative">
              <v-btn fab small color="white" class="btn-close-dialog-icon" @click="dialog.payment_guide = false">
                <v-icon>
                  mdi-close
                </v-icon>
              </v-btn>
            </div>
            <v-sheet class="sheet-border">
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
                    <template v-if="!$isEmpty(order.payment_log) && order.payment_log.va_bank_code">
                      <div class="mt-2 font-18 font-weight-700 mb-4">
                        {{ $t('v2.payment_guide') }}
                      </div>
                      <v-expansion-panels flat class="panel-guide" style="margin-right: -16px; margin-left: -16px;">
                        <template v-if="order.payment_log.va_bank_code === 'MANDIRI'">
                          <v-expansion-panel>
                            <v-expansion-panel-header class="pa-4 font-weight-600">
                              ATM MANDIRI
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <ol class="font-14">
                                <li v-for="(item, index) in $t('v2.atm_mandiri_guide')" :key="index" v-html="item.replace('{{ vaNumber }}', order.payment_log.va_account_number)" />
                              </ol>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                          <v-expansion-panel>
                            <v-expansion-panel-header class="pa-4 font-weight-600">
                              Mobile Banking
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <ol class="font-14">
                                <li v-for="(item, index) in $t('v2.mandiri_mobile')" :key="index" v-html="item.replace('{{ vaNumber }}', order.payment_log.va_account_number)" />
                              </ol>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                          <v-expansion-panel>
                            <v-expansion-panel-header class="pa-4 font-weight-600">
                              Internet Banking
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <ol class="font-14">
                                <li v-for="(item, index) in $t('v2.mandiri_ibanking')" :key="index" v-html="item.replace('{{ vaNumber }}', order.payment_log.va_account_number)" />
                              </ol>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </template>
                        <template v-if="order.payment_log.va_bank_code === 'BNI'">
                          <v-expansion-panel>
                            <v-expansion-panel-header class="pa-4 font-weight-600">
                              ATM BNI
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <ol class="font-14">
                                <li v-for="(item, index) in $t('v2.bni_atm')" :key="index" v-html="item.replace('{{ vaNumber }}', order.payment_log.va_account_number)" />
                              </ol>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                          <v-expansion-panel>
                            <v-expansion-panel-header class="pa-4 font-weight-600">
                              Mobile Banking BNI
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <ol class="font-14">
                                <li v-for="(item, index) in $t('v2.bni_mobile')" :key="index" v-html="item.replace('{{ vaNumber }}', order.payment_log.va_account_number)" />
                              </ol>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                          <v-expansion-panel>
                            <v-expansion-panel-header class="pa-4 font-weight-600">
                              Internet Banking BNI
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <ol class="font-14">
                                <li v-for="(item, index) in $t('v2.bni_internet')" :key="index" v-html="item.replace('{{ vaNumber }}', order.payment_log.va_account_number)" />
                              </ol>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </template>
                        <template v-if="order.payment_log.va_bank_code === 'BRI'">
                          <v-expansion-panel>
                            <v-expansion-panel-header class="pa-4 font-weight-600">
                              ATM BRI
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <ol class="font-14">
                                <li v-for="(item, index) in $t('v2.bri_atm')" :key="index" v-html="item.replace('{{ vaNumber }}', order.payment_log.va_account_number)" />
                              </ol>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                          <v-expansion-panel>
                            <v-expansion-panel-header class="pa-4 font-weight-600">
                              Mobile Banking
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <ol class="font-14">
                                <li v-for="(item, index) in $t('v2.bri_mobile')" :key="index" v-html="item.replace('{{ vaNumber }}', order.payment_log.va_account_number)" />
                              </ol>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                          <v-expansion-panel>
                            <v-expansion-panel-header class="pa-4 font-weight-600">
                              Internet Banking
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <ol class="font-14">
                                <li v-for="(item, index) in $t('v2.bri_internet')" :key="index" v-html="item.replace('{{ vaNumber }}', order.payment_log.va_account_number)" />
                              </ol>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </template>
                        <template v-if="order.payment_log.va_bank_code === 'PERMATA'">
                          <v-expansion-panel>
                            <v-expansion-panel-header class="pa-4 font-weight-600">
                              ATM PRIMA / ALTO:
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <ol class="font-14">
                                <li v-for="(item, index) in $t('v2.atm_prima')" :key="index" v-html="item.replace('{{ vaNumber }}', order.payment_log.va_account_number)" />
                              </ol>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                          <v-expansion-panel>
                            <v-expansion-panel-header class="pa-4 font-weight-600">
                              Permata Mobile X
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <ol class="font-14">
                                <li v-for="(item, index) in $t('v2.permata_mobile_x')" :key="index" v-html="item.replace('{{ vaNumber }}', order.payment_log.va_account_number)" />
                              </ol>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                          <v-expansion-panel>
                            <v-expansion-panel-header class="pa-4 font-weight-600">
                              Permata Mobile
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <ol class="font-14">
                                <li v-for="(item, index) in $t('v2.permata_mobile')" :key="index" v-html="item.replace('{{ vaNumber }}', order.payment_log.va_account_number)" />
                              </ol>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                          <v-expansion-panel>
                            <v-expansion-panel-header class="pa-4 font-weight-600">
                              Internet Banking Permata (PermataNet)
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <ol class="font-14">
                                <li v-for="(item, index) in $t('v2.permata_internet_banking')" :key="index" v-html="item.replace('{{ vaNumber }}', order.payment_log.va_account_number)" />
                              </ol>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </template>
                        <template v-if="order.payment_log.va_bank_code === 'BCA'">
                          <v-expansion-panel>
                            <v-expansion-panel-header class="pa-4 font-weight-600">
                              ATM BCA
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <ol class="font-14">
                                <li v-for="(item, index) in $t('v2.bca_atm')" :key="index" v-html="item.replace('{{ vaNumber }}', order.payment_log.va_account_number)" />
                              </ol>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                          <v-expansion-panel>
                            <v-expansion-panel-header class="pa-4 font-weight-600">
                              BCA M-Mobile
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <ol class="font-14">
                                <li v-for="(item, index) in $t('v2.bca_mobile')" :key="index" v-html="item.replace('{{ vaNumber }}', order.payment_log.va_account_number)" />
                              </ol>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                          <v-expansion-panel>
                            <v-expansion-panel-header class="pa-4 font-weight-600">
                              IBanking
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                              <ol class="font-14">
                                <li v-for="(item, index) in $t('v2.bca_ibanking')" :key="index" v-html="item.replace('{{ vaNumber }}', order.payment_log.va_account_number)" />
                              </ol>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </template>
                      </v-expansion-panels>
                    </template>
                    <template v-else>
                      <div class="mt-2 font-18 font-weight-700 mb-4">
                        {{ $t('v2.how_to_pay_with_qris') }}
                      </div>
                      <ol class="list-qris-guide">
                        <li>
                          {{ $t('v2.press_the_download_qris_button') }}
                        </li>
                        <li>
                          {{ $t('v2.oppen_an_eWallet_ebanking') }}
                        </li>
                        <li>
                          {{ $t('v2.look_for_the_qris_scan_option') }}
                        </li>
                        <li>
                          {{ $t('v2.after_scanning_the_total_transaction_price_will_appear') }}
                        </li>
                        <li>
                          {{ $t('v2.confirm_and_pay') }}
                        </li>
                        <li>
                          {{ $t('v2.you_have_successfully_paid') }}
                        </li>
                      </ol>
                    </template>
                  </v-col>
                </v-row>
              </v-container>
            </v-sheet>
          </v-bottom-sheet>
          <v-dialog v-model="dialog.confirm_cancel" persistent max-width="350">
            <v-card class="br-10">
              <div class="pa-4">
                <div class="text-center font-18 font-weight-700 mb-4">
                  {{ $t('v2.are_you_sure_want_to_cancel_the_order') }}
                </div>
                <div class="card-action-button">
                  <div class="card-action-item-button">
                    <v-btn block color="white" height="40" class="text-none font-weight-700 ol-black letter-spacing-normal ol-elevation-1 br-5" @click="dialog.confirm_cancel = false">
                      {{ $t('v2.cancel2') }}
                    </v-btn>
                  </div>
                  <div class="card-action-item-button">
                    <v-btn block color="white" height="40" class="text-none font-weight-700 ol-red letter-spacing-normal ol-elevation-1 br-5" @click="cancelOrder(order.id)">
                      {{ $t('v2.yes_cancel') }}
                    </v-btn>
                  </div>
                </div>
              </div>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialog.live_tracking" max-width="350">
            <v-card>
              <div class="pa-4">
                <div class="d-flex align-center mb-3">
                  <v-spacer />
                  <v-btn icon @click="dialog.live_tracking = false">
                    <v-icon>
                      mdi-close
                    </v-icon>
                  </v-btn>
                </div>
                <div>
                  <div class="col-square mb-4">
                    <div class="content-square">
                      <embed v-if="order.shipping_log && !$isEmpty(order.shipping_log.shipper) && order.shipping_log.shipper.live_tracking" type="text/html" :src="order.shipping_log.shipper.live_tracking" width="100%" height="600">
                    </div>
                  </div>
                </div>
              </div>
            </v-card>
          </v-dialog>
          <alert v-model="dialog_alert.show" :type="dialog_alert.type" :message="dialog_alert.message" />
          <v-bottom-sheet v-model="dialog.chat" persistent content-class="sheet-full">
            <v-sheet style="height: 100%" class="br-0">
              <div class="sheet-app-bar">
                <div class="sheet-app-bar-content">
                  <v-container class="px-0">
                    <v-row>
                      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
                        <div class="flex-image">
                          <div class="flex-image-avatar mr-2">
                            <v-btn icon width="40" height="40" @click="closeSheetChat">
                              <v-icon>
                                mdi-arrow-left
                              </v-icon>
                            </v-btn>
                          </div>
                          <div v-if="!$isEmpty(order.logo)" class="flex-image-avatar mr-2">
                            <img :src="order.logo.original" :alt="order.store_name" class="image-40">
                          </div>
                          <div class="flex-image-content">
                            <div class="flex-image-content-text font-20 font-weight-bold">
                              {{ order.store_name }}
                            </div>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-container>
                </div>
              </div>
              <v-form id="frmChat">
                <v-container class="pt-0">
                  <v-row>
                    <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pt-0">
                      <div class="flex-image chat-note">
                        <div class="flex-image-avatar mr-2">
                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M1.66669 10.0001C1.66669 5.40508 5.40502 1.66675 10 1.66675C14.595 1.66675 18.3334 5.40508 18.3334 10.0001C18.3334 14.5951 14.595 18.3334 10 18.3334C5.40502 18.3334 1.66669 14.5951 1.66669 10.0001ZM3.33335 10.0001C3.33335 13.6759 6.32419 16.6667 10 16.6667C13.6759 16.6667 16.6667 13.6759 16.6667 10.0001C16.6667 6.32425 13.6759 3.33341 10 3.33341C6.32419 3.33341 3.33335 6.32425 3.33335 10.0001ZM10.8334 14.1667V9.16675H9.16669V14.1667H10.8334ZM10.8334 7.50008V5.83342H9.16669V7.50008H10.8334Z" fill="#272727" />
                          </svg>
                        </div>
                        <div class="flex-image-content">
                          <div v-if="messages.length === 3" class="flex-image-content-text font-14 font-weight-400">
                            {{ $t('v2.request_maximum_quota') }}
                          </div>
                          <div v-else-if="messages.length === 0" class="flex-image-content-text font-14 font-weight-400">
                            {{ $t('v2.add_special_requests_to_restaurants') }}
                          </div>
                          <div v-else class="flex-image-content-text font-14 font-weight-400">
                            {{ $t('v2.you_can_call_the_waiter') }}
                          </div>
                        </div>
                      </div>
                      <div class="chat-list">
                        <div v-for="(item, idx) in messages" :key="idx" class="chat-list-item">
                          <div class="bubble-chat">
                            <div class="bubble-chat-message">
                              <div class="bubble-chat-text text-request">
                                {{ $t('v2.request') }} {{ idx + 1 }}
                              </div>
                              <div class="bubble-chat-text text-content">
                                {{ item.message }}
                              </div>
                            </div>
                            <div class="bubble-chat-deliv">
                              <div class="bubble-chat-deliv-icon d-flex">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M1.59595 9.16144L4.75795 11.5748L9.83528 5.77211L8.83128 4.89478L4.57528 9.75877L2.40395 8.10144L1.59595 9.16144ZM14.5019 5.77211L13.4979 4.89478L9.25195 9.74744L8.74995 9.34611L7.91661 10.3874L9.41461 11.5861L14.5019 5.77211Z" :fill="item.fstatus === 'read' ? '#0078CE' : '#CECECE'" />
                                </svg>
                              </div>
                              <div class="bubble-chat-deliv-time">
                                <div>
                                  {{ timechat(idx) }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <ValidationObserver v-if="messages.length < 3" ref="observer" v-slot="{ invalid, validated, passes, validate }">
                        <div class="mt-4 mb-2">
                          <label class="font-12">{{ $t('v2.request') }}</label>
                          <ValidationProvider v-slot="{ errors, valid }" name="message" rules="required|max:50">
                            <v-textarea v-model="form_chat.message" outlined rows="3" :placeholder="$t('v2.example_message')" hide-details dense class="inputv2-space" />
                            <div class="v-text-field__details mt-1">
                              <div :class="['v-messages', { 'ol-grey-content': valid || !validated, 'error--text': errors.length }]">
                                <div class="v-messages__message message-transition-enter-to">
                                  {{ $t('v2.max_50_characters') }}
                                </div>
                              </div>
                            </div>
                            <!-- v-textarea -->
                          </ValidationProvider>
                        </div>
                        <v-btn color="primary" block height="40" :disabled="invalid" class="text-none white--text br-5 font-weight-700 ol-elevation-1 letter-spacing-normal" @click="sendMessage()">
                          {{ $t('v2.send') }}
                        </v-btn>
                      </ValidationObserver>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-sheet>
          </v-bottom-sheet>
          <v-bottom-sheet v-model="dialog.split_bill" persistent content-class="sheet-full">
            <v-sheet style="height: 100%" class="br-0">
              <div class="sheet-app-bar">
                <div class="sheet-app-bar-content">
                  <v-container class="px-0">
                    <v-row>
                      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
                        <div class="flex-image">
                          <div class="flex-image-avatar mr-2">
                            <v-btn icon width="40" height="40" @click="closeSplitBill()">
                              <v-icon>
                                mdi-arrow-left
                              </v-icon>
                            </v-btn>
                          </div>
                          <div class="flex-image-content">
                            <div class="flex-image-content-text font-20 font-weight-bold">
                              {{ $t('v2.split_bill') }}
                            </div>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-container>
                </div>
              </div>
              <v-container class="pt-0">
                <v-row>
                  <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pt-0">
                    <template v-if="split_bill.step === 'form'">
                      <div v-if="split_bill.people.length > 0" class="mb-4">
                        <div class="font-12 font-weight-600 mb-2 ol-grey-content">
                          {{ $t('v2.people_added') }} ({{ split_bill.people.length }})
                        </div>
                        <div v-for="person in split_bill.people" :key="person.id" class="d-flex align-center mb-2">
                          <div class="font-14 font-weight-600">
                            {{ person.name }}
                          </div>
                          <div class="font-12 ol-grey-content ml-2">
                            {{ person.item_idx.length }} item
                          </div>
                          <v-spacer />
                          <v-btn icon small @click="removePersonSplitBill(person.id)">
                            <v-icon size="18">
                              mdi-close
                            </v-icon>
                          </v-btn>
                        </div>
                        <div class="div-line my-3" />
                      </div>

                      <label class="font-12">{{ $t('v2.person_name') }}</label>
                      <v-text-field v-model="split_bill.current_name" outlined dense hide-details :placeholder="$t('v2.person_name_placeholder')" class="inputv2-space mb-4" />

                      <label class="font-12">{{ $t('v2.select_menu_for', { name: split_bill.current_name || '...' }) }}</label>
                      <div v-for="(item, idx) in splitBillItems" :key="idx" class="d-flex align-center py-2">
                        <v-checkbox v-model="split_bill.current_item_idx" :value="idx" hide-details class="mt-0 pt-0" />
                        <div class="ml-2">
                          <div class="font-14 font-weight-600">
                            {{ item.qty }}x {{ item.item_name }} {{ item.item_variant_name ? '(' + item.item_variant_name + ')' : '' }}
                          </div>
                          <div class="font-12 ol-grey-content">
                            <span v-mask-money="item.amount" />
                          </div>
                        </div>
                      </div>

                      <v-btn outlined color="olbrand" block height="40" class="text-none br-5 font-weight-700 letter-spacing-normal mt-4" :disabled="!split_bill.current_name || split_bill.current_item_idx.length === 0" @click="addPersonSplitBill()">
                        {{ $t('v2.add_another_person') }}
                      </v-btn>
                      <v-btn color="primary" block height="40" class="text-none white--text br-5 font-weight-700 ol-elevation-1 letter-spacing-normal mt-2" :disabled="split_bill.people.length === 0 && (!split_bill.current_name || split_bill.current_item_idx.length === 0)" @click="showSplitBillResult()">
                        {{ $t('v2.view_result') }}
                      </v-btn>
                    </template>
                    <template v-else>
                      <div v-for="result in splitBillResult" :key="result.id" class="mb-4 pa-3 ol-elevation-2 br-8">
                        <div class="d-flex align-center mb-2">
                          <div class="font-16 font-weight-700">
                            {{ result.name }}
                          </div>
                          <v-spacer />
                          <div class="font-16 font-weight-700">
                            <span v-mask-money="result.total" />
                          </div>
                        </div>
                        <div v-for="line in result.lines" :key="line.idx" class="d-flex font-12 ol-grey-content">
                          <div>
                            {{ line.qty }}x {{ line.name }}<span v-if="line.shared_count > 1"> ({{ $t('v2.shared_with', { count: line.shared_count }) }})</span>
                          </div>
                          <v-spacer />
                          <span v-mask-money="line.share_amount" />
                        </div>
                        <template v-if="result.fees.length > 0">
                          <div class="div-line my-2" />
                          <div v-for="fee in result.fees" :key="fee.key" class="d-flex font-12 ol-grey-content">
                            <div>
                              {{ fee.label }}
                            </div>
                            <v-spacer />
                            <span v-mask-money="fee.amount" />
                          </div>
                        </template>
                      </div>

                      <div v-if="splitBillUnassignedItems.length > 0" class="mb-4 pa-3 bg-grey br-8">
                        <div class="font-12 font-weight-600 mb-2">
                          {{ $t('v2.unassigned_items') }}
                        </div>
                        <div v-for="(item, idx) in splitBillUnassignedItems" :key="idx" class="font-12 ol-grey-content">
                          {{ item.qty }}x {{ item.item_name }}
                        </div>
                      </div>

                      <div class="font-12 ol-grey-content mb-4">
                        {{ $t('v2.split_bill_estimation_note') }}
                      </div>

                      <v-btn color="primary" block height="40" class="text-none white--text br-5 font-weight-700 ol-elevation-1 letter-spacing-normal mb-2" @click="shareSplitBillResult()">
                        {{ $t('v2.share_result') }}
                      </v-btn>
                      <v-btn outlined color="olbrand" block height="40" class="text-none br-5 font-weight-700 letter-spacing-normal" @click="split_bill.step = 'form'">
                        {{ $t('v2.back_to_edit') }}
                      </v-btn>
                    </template>
                  </v-col>
                </v-row>
              </v-container>
            </v-sheet>
          </v-bottom-sheet>
          <v-dialog v-model="dialog.qris_image" max-width="350">
            <v-card v-if="!$isEmpty(order.payment_log) && order.payment_log.qr_image">
              <div class="pa-4">
                <div class="d-flex align-center mb-3">
                  <v-spacer />
                  <v-btn icon @click="dialog.qris_image = false">
                    <v-icon>
                      mdi-close
                    </v-icon>
                  </v-btn>
                </div>
                <div>
                  <div class="col-square mb-4">
                    <div class="content-square">
                      <img :src="order.payment_log.qr_image" alt="" class="image-responsive">
                    </div>
                  </div>
                  <v-btn :href="order.payment_log.qr_image" download="QRIS.png" block color="primary" height="40" class="text-none">
                    <v-icon left>
                      mdi-download
                    </v-icon>
                    {{ $t('v2.download_qris') }}
                  </v-btn>
                </div>
              </div>
            </v-card>
          </v-dialog>
          <alert v-model="dialog_alert.show" :type="dialog_alert.type" :message="dialog_alert.message" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import {
  ValidationObserver,
  ValidationProvider
} from 'vee-validate'
import {
  getDataDetail as getDataDetailOrder,
  cancelOrder as cancelDataOrder,
  createChat,
  getChat
} from '@/api/order'
import {
  hitPoint as hitDataPoint
} from '@/api/point'
import {
  hitDiscount as hitDataDiscount
} from '@/api/discount'
import {
  checkMaterial as checkStockMaterial
} from '@/api/product'
import Alert from '@/components/v2/Alert'
import Lottie from 'vue-lottie'
import pending from '@/assets/json/pending.json'
import confirm from '@/assets/json/confirm.json'
import search from '@/assets/json/search.json'
import shipping from '@/assets/json/shipping.json'
import { checkInventory, prepareCartItem, validateStockMaterial } from '@/utils/order'
export default {
  components: {
    Lottie,
    Alert,
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      dialog_alert: {
        show: false,
        type: 'success',
        message: ''
      },
      pendingOption: {
        animationData: pending
      },
      searchOption: {
        animationData: search
      },
      shippingOption: {
        animationData: shipping
      },
      confirmOption: {
        animationData: confirm
      },
      dialog: {
        confirm_cancel: false,
        payment_guide: false,
        live_tracking: false,
        chat: false,
        split_bill: false
      },
      icon_table: require('@/assets/images/v2/img/icon_table.png'),
      icon_side_reservation: require('@/assets/images/v2/img/icon-side-reservation.png'),
      icon_side_delivery: require('@/assets/images/v2/img/icon-side-delivery.png'),
      order: {},
      expired_time: 0,
      timerOrderInterval: null,
      cart: {},
      temp_cart: {},
      form_chat: {
        table_no: '',
        message: ''
      },
      messages: [],
      materials: [],
      split_bill: {
        step: 'form',
        people: [],
        current_name: '',
        current_item_idx: []
      }
    }
  },
  computed: {
    splitBillItems() {
      if (!this.order || !this.order.items) return []
      return this.order.items.filter((item) => item.note !== 'REDEEMED')
    },
    splitBillAssigneeCount() {
      const count = {}
      this.split_bill.people.forEach((person) => {
        person.item_idx.forEach((idx) => {
          count[idx] = (count[idx] || 0) + 1
        })
      })
      return count
    },
    splitBillUnassignedItems() {
      const count = this.splitBillAssigneeCount
      return this.splitBillItems.filter((item, idx) => !count[idx])
    },
    splitBillFeeFields() {
      const order = this.order
      const isPointDiscount = !this.$isEmpty(order.points) && order.points.type === 'D'
      return [
        { key: 'discount', label: this.$t('v2.discount'), amount: Number(order.discount_amount) || 0, sign: -1 },
        { key: 'points', label: this.$t('v2.voucher_point'), amount: isPointDiscount ? Number(order.points.redeemed_amount) || 0 : 0, sign: -1 },
        { key: 'service_charge', label: this.$t('v2.service_charge'), amount: Number(order.service_charge_amount) || 0, sign: 1 },
        { key: 'shipping', label: this.$t('v2.delivery_fee'), amount: Number(order.shipping_cost) || 0, sign: 1 },
        { key: 'trans_fee', label: this.$t('v2.convenience_fee'), amount: Number(order.trans_fee_amount) || 0, sign: 1 },
        { key: 'tax', label: this.$store.state.selected_outlet.tax_name ? this.$store.state.selected_outlet.tax_name : this.$t('v2.tax'), amount: Number(order.tax_amount) || 0, sign: 1 },
        { key: 'rounding', label: this.$t('v2.rounding'), amount: Number(order.rounded_amount) || 0, sign: 1 }
      ]
    },
    splitBillResult() {
      const assigneeCount = this.splitBillAssigneeCount
      const items = this.splitBillItems
      const subtotal = Number(this.order.order_amount) || 0
      const feeFields = this.splitBillFeeFields.filter((fee) => fee.amount > 0)
      return this.split_bill.people.map((person) => {
        let personSubtotal = 0
        const lines = person.item_idx.map((idx) => {
          const item = items[idx]
          const sharedCount = assigneeCount[idx] || 1
          const shareAmount = Number(item.amount) / sharedCount
          personSubtotal += shareAmount
          return {
            idx,
            name: item.item_name + (item.item_variant_name ? ' (' + item.item_variant_name + ')' : ''),
            qty: item.qty,
            shared_count: sharedCount,
            share_amount: shareAmount
          }
        })
        const ratio = subtotal > 0 ? personSubtotal / subtotal : 0
        const fees = feeFields.map((fee) => ({
          key: fee.key,
          label: fee.label,
          amount: fee.sign * (ratio * fee.amount)
        }))
        const feesTotal = fees.reduce((sum, fee) => sum + fee.amount, 0)
        return {
          id: person.id,
          name: person.name,
          lines,
          fees,
          total: Math.round(personSubtotal + feesTotal)
        }
      })
    },
    shippingDetail() {
      let arryText = []
      const obj = {
        name: '',
        detail: ''
      }
      if (this.order.shipping_address && this.order.shipping_address !== '') {
        arryText = this.order.shipping_address.split('--')
      }
      obj.name = arryText[0]
      obj.detail = arryText[1]
      return obj
    },
    formattedTimeLeft() {
      let days = Math.floor(this.expired_time / (1000 * 60 * 60 * 24))
      let hours = Math.floor((this.expired_time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      let minutes = Math.floor((this.expired_time % (1000 * 60 * 60)) / (1000 * 60))
      let seconds = Math.floor((this.expired_time % (1000 * 60)) / 1000)
      let result
      if (this.expired_time < 0) {
        result = 'EXPIRED'
      } else {
        days = days === 0 ? '' : days + ' : '
        hours = hours < 10 ? hours === 0 ? '' : '0' + hours + ' : ' : hours + ' : '
        minutes = minutes < 10 ? '0' + minutes + ':' : minutes + ':'
        seconds = seconds < 10 ? '0' + seconds : seconds
        result = days + hours + minutes + seconds
      }
      return result
    },
    driverDetail() {
      let driver = {}
      if (this.order.shipping_log && !this.$isEmpty(this.order.shipping_log) && this.order.shipping_log.shipper && !this.$isEmpty(this.order.shipping_log.shipper) && this.order.shipping_log.shipper.driver !== '') {
        driver = driver = typeof this.order.shipping_log.shipper.driver === 'string' ? JSON.parse(this.order.shipping_log.shipper.driver) : this.order.shipping_log.shipper.driver
      }
      return driver
    },
    shipperSearch() {
      if (this.order.shipping_log && !this.$isEmpty(this.order.shipping_log)) {
        if (this.order.shipping_log.shipper && !this.$isEmpty(this.order.shipping_log.shipper)) {
          if (this.order.shipping_log.shipper.status_code === '1001' || this.order.shipping_log.shipper.status_code === '1160' || this.order.shipping_log.shipper.status_code === '1170' || this.order.shipping_log.shipper.status_code === '1180' || this.order.shipping_log.shipper.status_code === '2000') {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      } else {
        return false
      }
    },
    shipperDelivery() {
      let driver = {}
      if (this.order.shipping_log && !this.$isEmpty(this.order.shipping_log)) {
        if (this.order.shipping_log.shipper && !this.$isEmpty(this.order.shipping_log.shipper)) {
          if (this.order.shipping_log.shipper.driver !== '') {
            driver = typeof this.order.shipping_log.shipper.driver === 'string' ? JSON.parse(this.order.shipping_log.shipper.driver) : this.order.shipping_log.shipper.driver
          }
          if (this.order.shipping_delivery_type === '2' && this.order.shipping_courier_id === 'S08') {
            if ((this.order.shipping_log.shipper.status_code === '1160' && driver.name !== '') || this.order.shipping_log.shipper.status_code === '1170' || this.order.shipping_log.shipper.status_code === '1180' || this.order.shipping_log.shipper.status_code === '2000') {
              return true
            } else {
              return false
            }
          } else {
            if ((this.order.shipping_log.shipper.status_code === '1160' && driver.name !== '') || this.order.shipping_log.shipper.status_code === '1170' || this.order.shipping_log.shipper.status_code === '1180' || this.order.shipping_log.shipper.status_code === '2000') {
              return true
            } else {
              return false
            }
          }
        } else {
          return false
        }
      } else {
        return false
      }
    },
    shipperDelivered() {
      if (this.order.shipping_log && !this.$isEmpty(this.order.shipping_log)) {
        if (this.order.shipping_log.shipper && !this.$isEmpty(this.order.shipping_log.shipper)) {
          if (this.order.shipping_log.shipper.status_code === '2000') {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      } else {
        return false
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.timerOrderInterval)
  },
  mounted() {
    this.getOrder()
    const LOCAL_DATA_CART = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_v2_cart')
    if (LOCAL_DATA_CART) {
      this.cart = JSON.parse(LOCAL_DATA_CART)
    }
  },
  methods: {
    goBack() {
      this.$router.push({ name: '_orders' }).catch(() => {})
    },
    timechat(idx) {
      const data_timezone = this.messages[idx].created_at.timezone
      const d = new Date(this.messages[idx].created_at.date)
      var hour = ''
      const minute = d.getMinutes()
      if (data_timezone === 'Asia/Jakarta' || data_timezone === 'Asia/Pontianak') {
        hour = d.getHours()
      } else if (data_timezone === 'Asia/Makassar') {
        hour = Number(d.getHours()) + 1
      } else if (data_timezone === 'Asia/Jayapura') {
        hour = Number(d.getHours()) + 2
      }
      return hour + ':' + minute
    },
    async getMessage() {
      try {
        const { data } = await getChat(this.$route.params.id)
        this.messages = data.data
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    },
    async sendMessage() {
      const isValid = await this.$refs.observer.validate()
      if (isValid) {
        try {
          this.form_chat.table_no = this.order.table_no
          const { data } = await createChat(this.$route.params.id, this.form_chat)
          this.messages.push(data.data)
          this.form_chat.message = ''
          this.$refs.observer.reset()
          this.$store.state.show_error = true
          this.$store.state.error_message = this.$t('v2.request_has_been_sent')
          this.$store.state.error_type = 200
        } catch (e) {
          this.$store.state.show_error = true
          this.$store.state.error_message = e.string
          this.$store.state.error_type = e.statusCode
        }
      }
    },
    closeSheetChat() {
      this.dialog.chat = false
    },
    showDialogCallWaiter() {
      this.getMessage()
      this.dialog.chat = true
    },
    splitBillStorageKeyPrefix() {
      return process.env.VUE_APP_COOKIE_KEY + '_split_bill_'
    },
    splitBillStorageKey() {
      return this.splitBillStorageKeyPrefix() + this.order.id
    },
    cleanupSplitBillDrafts() {
      const prefix = this.splitBillStorageKeyPrefix()
      const maxAgeMs = 7 * 24 * 60 * 60 * 1000
      const now = Date.now()
      Object.keys(localStorage)
        .filter((key) => key.indexOf(prefix) === 0)
        .forEach((key) => {
          try {
            const draft = JSON.parse(localStorage.getItem(key))
            if (!draft || !draft.updated_at || (now - draft.updated_at) > maxAgeMs) {
              localStorage.removeItem(key)
            }
          } catch (e) {
            localStorage.removeItem(key)
          }
        })
    },
    loadSplitBillDraft() {
      try {
        const raw = localStorage.getItem(this.splitBillStorageKey())
        const draft = raw ? JSON.parse(raw) : null
        return draft && draft.people ? draft.people : []
      } catch (e) {
        return []
      }
    },
    saveSplitBillDraft() {
      localStorage.setItem(this.splitBillStorageKey(), JSON.stringify({
        people: this.split_bill.people,
        updated_at: Date.now()
      }))
    },
    openSplitBill() {
      this.cleanupSplitBillDrafts()
      this.split_bill = {
        step: 'form',
        people: this.loadSplitBillDraft(),
        current_name: '',
        current_item_idx: []
      }
      this.dialog.split_bill = true
    },
    closeSplitBill() {
      this.dialog.split_bill = false
    },
    addPersonSplitBill() {
      if (!this.split_bill.current_name || this.split_bill.current_item_idx.length === 0) return
      this.split_bill.people.push({
        id: this.split_bill.people.length + 1,
        name: this.split_bill.current_name.trim(),
        item_idx: [...this.split_bill.current_item_idx]
      })
      this.split_bill.current_name = ''
      this.split_bill.current_item_idx = []
      this.saveSplitBillDraft()
    },
    removePersonSplitBill(id) {
      this.split_bill.people = this.split_bill.people.filter((person) => person.id !== id)
      this.saveSplitBillDraft()
    },
    showSplitBillResult() {
      if (this.split_bill.current_name && this.split_bill.current_item_idx.length > 0) {
        this.addPersonSplitBill()
      }
      this.split_bill.step = 'result'
    },
    async shareSplitBillResult() {
      const lines = [this.$t('v2.split_bill') + ' - ' + this.order.store_name]
      this.splitBillResult.forEach((result) => {
        lines.push('')
        lines.push(result.name + ': ' + this.$maskMoney(result.total))
        result.lines.forEach((line) => {
          lines.push('- ' + line.qty + 'x ' + line.name + ': ' + this.$maskMoney(line.share_amount))
        })
        result.fees.forEach((fee) => {
          lines.push('- ' + fee.label + ': ' + this.$maskMoney(fee.amount))
        })
      })
      const text = lines.join('\n')
      if (navigator.share) {
        try {
          await navigator.share({ title: this.$t('v2.split_bill'), text })
        } catch (e) {
          // user membatalkan share sheet
        }
      } else if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(text)
        this.$store.state.show_error = true
        this.$store.state.error_message = this.$t('v2.split_bill_copied')
        this.$store.state.error_type = 200
      }
    },
    fetchChat() {
      const socket = window.io('https://socket.all.olsera.indociti.com/antarinmakan/status', {
        withCredentials: true,
        extraHeaders: {
          'Authorization': '3XxxIIlIyJpiZ4QdlHIn50A5K2bOMxB3',
          'X-Order-Id': this.order.id
        }
      })

      socket.on('connect', () => {
        console.log('socket connected to chat')
      })

      socket.on('status', (msg) => {
        try {
          const idx = this.messages.findIndex((e) => {
            return e.id === msg.chat_id
          })
          if (idx !== -1) {
            this.messages[idx].status = msg.status
          }
        } catch (error) {
          console.log(error)
        }
      })
    },
    fetchShipper() {
      const socket = window.io('https://socket.all.olsera.indociti.com/shipper', {
        withCredentials: true,
        extraHeaders: {
          'Authorization': 'kYzfJORMSFSVmHCEZCiEpcwC669ig6Ab'
        }
      })

      socket.on('connect', () => {
        console.log('socket connected to shipper')
      })

      socket.on('shipper-olsera', (msg) => {
        try {
          const response = JSON.parse(JSON.stringify(msg))
          this.order.shipping_log.shipper = response.data.detail
        } catch (error) {
          console.log(error)
        }
      })
    },
    openTracking() {
      this.dialog.live_tracking = true
    },
    notTakeaway(note) {
      const arrNote = note.split(',')
      if (arrNote[0] === 'TAKE AWAY') {
        arrNote.splice(0, 1)
      }
      return arrNote.toString()
    },
    isTakeaway(note) {
      const arrNote = note.split(',')
      if (arrNote[0] === 'TAKE AWAY') {
        return true
      }
      return false
    },
    refreshPage() {
      location.reload()
    },
    async cancelOrder(id) {
      try {
        let params = {}
        if (this.$store.state.selected_store.setting.no_auth_dinein) {
          params = {
            remark: 'OL-DINE-IN'
          }
        }
        await cancelDataOrder(id, params)
        this.dialog_alert.show = true
        this.dialog_alert.message = this.$t('v2.order_successfully_cancelled')
        this.dialog.confirm_cancel = false
        setTimeout(() => {
          this.$router.push({ name: '_menu' }).catch(() => {})
        }, 3000)
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    },
    confirmCancel() {
      this.dialog.confirm_cancel = true
    },
    async getOrder() {
      try {
        let params = {}
        if (this.$store.state.selected_store.setting.no_auth_dinein) {
          params = {
            remark: 'OL-DINE-IN'
          }
        }
        const { data } = await getDataDetailOrder(this.$route.params.id, params)
        this.order = data.data
        if (!this.$isEmpty(this.order.payment_log) && this.order.payment_log.expired_at) {
          this.getExpiryTime(this.order.payment_log.expired_at)
        }
        if (this.order.is_paid) {
          clearInterval(this.timerOrderInterval)
        }
        if (this.order.status !== 'Z' && this.order.status !== 'X' && this.order.status !== 'P') {
          if (this.order.shipping_courier_id === 'S08' || this.order.shipping_courier_id === 'S09') {
            this.fetchShipper()
          }
        }
        if ((this.order.status_inquiry === 3 || this.order.status_inquiry === 4) && this.order.remark === 'OL-DINE-IN') {
          this.fetchChat()
        }
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    },
    textAddons(item) {
      if (item.product_combo_id) {
        const arr = []
        for (let i = 0; i < item.item_product_combo.length; i++) {
          arr.push(item.item_product_combo[i].item_name)
        }
        return arr.join(', ')
      } else {
        if (typeof item.addon !== 'undefined' && item.addon.length !== 0) {
          const names = item.addon.map(function(item) {
            return item['name']
          })
          return names.join(', ')
        } else {
          return ''
        }
      }
    },
    getExpiryTime(time) {
      var countDownDate = new Date(time).getTime()
      const _this = this
      this.timerOrderInterval = setInterval(function() {
        var now = new Date().getTime()
        _this.expired_time = countDownDate - now
        if (_this.expired_time < 0) {
          clearInterval(_this.timerOrderInterval)
        }
      }, 1000)
    },
    async checkStockMaterialObj(objId) {
      try {
        const { data } = await checkStockMaterial(objId)
        this.materials = data.data.materials
      } catch (e) {
        this.materials = []
        Object.assign(this.$store.state, {
          show_error: true,
          error_message: e.string,
          error_type: e.statusCode
        })
      }
    },
    async reOrder() {
      const cart = []
      let reorder = true
      for (const item of this.order.items) {
        if (item.product_has_material && !item.track_inventory) {
          await this.checkStockMaterialObj({
            product_id: item.product_id || undefined,
            product_variant_id: item.product_variant_id || undefined
          })
        }
        if (await checkInventory(item, this.materials)) {
          reorder = false
          break
        }
        if (item.note !== 'REDEEMED') {
          cart.push(prepareCartItem(item, this.materials))
        }
      }

      reorder = reorder && await validateStockMaterial(cart)

      if (reorder) {
        this.cart.item = cart
        await this.$store.dispatch('saveCartV2', this.cart)
        this.$router.push({ name: '_checkout' }).catch(() => {})
      }
    },
    copyText() {
      const testingCodeToCopy = document.querySelector('#va_account_number')
      testingCodeToCopy.setAttribute('type', 'text')
      testingCodeToCopy.select()
      try {
        var successful = document.execCommand('copy')
        var msg = successful ? this.$t('v2.successful') : this.$t('v2.unsuccessful')
        this.dialog_alert.show = true
        this.dialog_alert.message = this.$t('v2.number_copied', { status: msg })
      } catch (err) {
        this.dialog_alert.show = true
        this.dialog_alert.type = 'error'
        this.dialog_alert.message = 'Number was copied ' + msg
      }
      testingCodeToCopy.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    },
    async changePayment() {
      const cart = []
      let reorder = true
      for (const item of this.order.items) {
        if (item.product_has_material && !item.track_inventory) {
          await this.checkStockMaterialObj({
            product_id: item.product_id || undefined,
            product_variant_id: item.product_variant_id || undefined
          })
        }
        if (await checkInventory(item, this.materials)) {
          reorder = false
          break
        }
        if (item.note !== 'REDEEMED') {
          cart.push(prepareCartItem(item, this.materials))
        }
      }
      this.cart.item = cart

      reorder = reorder && await validateStockMaterial(cart)

      if (this.order.remark === 'DELIVERY') {
        const DETAIL_LOCATION = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_v2_location')
        if (DETAIL_LOCATION) {
          const detail_location = JSON.parse(DETAIL_LOCATION)
          this.locations = detail_location
        }
        const arrAdd = this.order.shipping_address.split('--')
        this.$set(this.locations, 'name', arrAdd[0].trim())
        this.$set(this.locations, 'shipping_address', arrAdd[1].trim())
        this.$set(this.locations, 'driver_note', '')
        this.$set(this.locations, 'shipping_lat', this.order.shipping_lat)
        this.$set(this.locations, 'shipping_lon', this.order.shipping_lon)
        this.$set(this.locations, 'shipping_radius', this.order.shipping_radius)
        this.$store.dispatch('saveLocationV2', this.locations)

        if (Number(this.order.shipping_delivery_type) === 1) {
          this.shipping.shipping_cost = Number(this.order.shipping_cost)
          this.shipping.shipping_courier_id = this.order.shipping_courier_id
          this.shipping.shipping_courier_name = this.$t('v2.restaurant_courier')
          this.shipping.shipping_delivery_type = 1
          this.shipping.shipping_logo = require('@/assets/images/v2/img/icon_restaurant_courier.png')
          this.shipping.shipping_time = this.order.shipping_time
        }
        this.$store.dispatch('saveShippingV2', this.shipping)
      }

      if (reorder) {
        if (!this.$isEmpty(this.order.points) && this.order.points.redeem_id) {
          await this.hitPoint()
        }
        if (this.order.discount_voucher_id) {
          await this.hitVoucher(this.order.discount_voucher_id)
        }
        this.cart.total_pay = Number(this.order.total_amount)
        this.cart.previousOrderId = this.order.id

        await this.$store.dispatch('saveCartV2', this.cart)
        this.$router.push({ name: '_payment' }).catch(() => {})
      }
    },
    async hitPoint() {
      this.cart.redeem_id = this.order.points.redeem_id
      this.cart.remark = this.order.remark
      const data_hit = { ...this.cart }
      try {
        const { data } = await hitDataPoint(data_hit)
        this.cart.requestId = data.requestId
        this.cart.redeemId = this.cart.redeem_id
        this.cart.point_detail = data.point_detail
      } catch (e) {
        if (e.statusCode === 401) {
          this.$store.dispatch('fetchToken')
        } else {
          this.$store.state.show_error = true
          this.$store.state.error_message = e.string
          this.$store.state.error_type = e.statusCode
        }
      }
      delete this.cart.redeem_id
      delete this.cart.remark
    },
    async hitVoucher(id) {
      const data_hit = { ...this.cart }
      data_hit.discount_id = id
      data_hit.remark = this.$store.state.selected_type
      this.$delete(this.cart, 'discount_voucher_id')
      this.$delete(this.cart, 'discount_detail')
      try {
        const { data } = await hitDataDiscount(data_hit)
        this.cart.discount_voucher_id = id
        this.$set(this.cart, 'discount_detail', data.data)
      } catch (e) {
        if (e.statusCode === 401) {
          this.$store.dispatch('fetchToken')
        } else {
          this.$store.state.show_error = true
          this.$store.state.error_message = e.string
          this.$store.state.error_type = e.statusCode
        }
      }
    }
  }
}
</script>
